(function() {
	'use strict';

	angular
		.module('stats', ['ui.router', 'ui.bootstrap'])
		.run(runRedirect);	
		
	function runRedirect($window) {
		$window.location.replace("https://umcdata.net/ChurchReporting");
	}	

/*
	function runBlock($location, webSessionStorage, $state, loginService, $rootScope,
		appValidationService, setCustService, modalService) {
		var sDatabaseID = "";
		var sDataSource = "";
		var searchObject = $location.search();
	
	var sRetCodeToDelete = "";

//searchObject.conf = "LA";			//*** TESTING   AR: 0799493 / 151553
// $rootScope.TESTING = true;
// searchObject.ReturnCode = "QHmd0DGa6jIBVegmNgYx"; 				//*** TESTING

/*
		if (searchObject.ReturnCode) {
			sRetCodeToDelete = searchObject.ReturnCode; }
		else if (webSessionStorage.getStoredData('sReturnCode') != null) {
			// if "Refresh" occurs, this allows login so as not to force
			//	user to manually login again:
			sRetCodeToDelete = webSessionStorage.getStoredData('sReturnCode');
		}
*/

		//Login with ReturnCode ==> LoginService calls SecDeleteReturnCode immediately after login
/*
		if (sRetCodeToDelete !=  "") {
			loginService.secReturnLogin(sRetCodeToDelete)
			.then(function (data) {
				if (data[0].DATABASEID != "") {
					sDataSource = data[0].DATABASEID;
					setCustService.fromDataSource(sDataSource);

					if (data[0].PARAMS === "PasswordReset") {
						$state.go('chgPW', { bHideOldPw: true });
					} else if (data[0].USERID != "") {
						loginService.login(data[0].USERNAME, data[0].PASSWORD)
						.then(function(loginReturn) {
							if (loginReturn[0].SECUSERLOGIN[0].RESULT == "Success") {

								// Determine landing page... 
								if (appValidationService.validateAccess() == "Valid") {
									$rootScope.sCurForm = 'Statistics Records';
									$state.go('statHist');
								} else {
									$rootScope.sCurForm = 'Login';
									$state.go('login');
								}
							}
						});
					} else if (data[0].USERNAME == "Expired") {
						modalService.okAlert("Expired",
							"Your session login has expired.<br><br>" +
							"Please log in again to continue.");
						$state.go('login');
					}
				}
			});
		}
*/

		//Login page with Conference identified:
/*
		else {
			if (searchObject.conf) {
				sDatabaseID = searchObject.conf;
				setCustService.fromDatabaseID(sDatabaseID);
			} else {
				webSessionStorage.setStoredData('sDataSource', "HelpFalcon");
			}
		}
	
	}
*/	
})();

(function () {
    'use strict';
    
    angular
        .module('stats')
        .factory('webSessionStorage', webSessionStorage);
        
    function webSessionStorage($window) {
        var store = $window.sessionStorage;
        var factory = {};
        
        factory.getStoredData = function (sKey) {
            return store.getItem(sKey);
        };
        
        factory.setStoredData = function (sKey, sData) {
            if (sData) {
                store.setItem(sKey, sData);
            }  
            else {
                store.removeItem(sKey);
            }
        };
        
        return factory;
	}
    
})();
(function () {
	'use strict';

	angular
		.module('stats')
		.factory('vancoService', vancoService);

	vancoService.$inject = ['$http','webSessionStorage','loginService','$rootScope','datesService',
		'errorEmailNotification','dataService','testCFC','returnURL','vancoPay','$httpParamSerializer',
		'$window','$log'];	

	function vancoService($http, webSessionStorage, loginService, $rootScope, datesService,
		errorEmailNotification, dataService, testCFC, returnURL, vancoPay, $httpParamSerializer, 
		$window, $log) {
		var sDataSource = "";
		
		var service = {
			goToVancoPayments: goToVancoPayments,
			saveRcvPaymentTransData: saveRcvPaymentTransData
		};
		return service;
		
		function goToVancoPayments(lastName, firstName) { $log.info("VancoService");
			sDataSource = webSessionStorage.getStoredData('sDataSource');
		/* Get Fee: */
			var params= {
				method: "LibGetASetting",
				sDataSource: sDataSource,
				sSetting: "ProBkgrdScreenFee"
			};
			return $http.post(testCFC, params)
            .then(function(results) {
                if (results.data.length > 0) {
					var fee = results.data[0].SETTINGVALUE;
					saveRcvPaymentTransData(lastName, firstName, fee);
				} else {
					var sEmailContent = errorEmailNotification.error4
						("WebApps_Pro/vancoService() LibGetBkgrdScreenFee");
					dataService.emailSendError(sEmailContent);
				}
            });
		}
		
		function saveRcvPaymentTransData(lastName, firstName, fee) {		
			var iRcvID = 0;
			var subItem = lastName + ", " + firstName;
			var sToday = datesService.todayToDbString();
			var curYear = datesService.currentYear();
			if (subItem.length > 20) {
				subItem = subItem.substr(0, 20);
			}
					
			var sRawDataString = "WebApps_Pro || vancoService || " + loginService.user.USERID +
				" || I || PaymentStatus==Started || BillingEntityID==" + 
				loginService.user.USERENTITYID + " || App==Protect || RcvItem==SS || RcvSubItem==" +
				subItem + " || RcvSubItemID==" + $rootScope.sProID + " || AmountToApply==" + 
				fee + " || AsOfDate==" + sToday + " || FinYear==" + curYear + " ^^ ";				
			var params1 = {
				method: "RcvSavePaymentTransData",
				sDataSource: sDataSource,
				sRawDataString: sRawDataString
			};
			return $http.post(testCFC, params1)
			.then(function(results1) {
				if (results1.data[0].RESULTCODE == "Success") {
					iRcvID = results1.data[0].RCVID;
$log.info("iRcvID:",iRcvID);

				/* Get a ReturnCode: */
					dataService.secGetReturnCode(10, "PayFee", loginService.user.USERID + "|" +
						loginService.user.USERFULLNAME)
					.then(function(result2) { 
						if (result2.length > 0) {
							var ReturnCode = result2[0].RETURNCODE;
$log.info("ReturnCode:",ReturnCode);

						/* Go To VancoPay app: */	
							if (iRcvID > 0) {
								var returnURLWithCode = returnURL + "?ReturnCode=" + ReturnCode;
								var params3 = {
									sDataSource: sDataSource,
									iUserID: loginService.user.USERID,
									App: "Protect",
									ReturnURL: returnURLWithCode,
									iRcvID: iRcvID
								};
								var paramsString = $httpParamSerializer(params3);
								var url = vancoPay + "?" + paramsString;
								$window.location.replace(url);
							}
						}
					});
				} else {
					var sEmailContent1 = "WebApps_Pro/vancoServices - RcvSavePaymentTransData()" +
						"<br><br>There was an error saving the Vanco Payment RcvPaymentTransData " +
						"for:<br>ProID: " + $rootScope.sProID + "<br>Payment Amount: " + fee +
						"<br><br>Error: " + results1.data[0].RESULTREASON;
					dataService.emailSendError(sEmailContent1);
				}
			});
		}
		
	}
})();
(function () {
    'use strict';
 
	angular
        .module('stats')
        .factory('validatorService', validatorService);

    function validatorService() {
		var service = {
			emailIsValid: emailIsValid,
			phoneIsValid: phoneIsValid
		};
		
		return service;
		
		function emailIsValid(sEmail) {
			var isValid = false;
			var filter = new RegExp(/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/);

			if (sEmail.search(filter) == -1) {
				return isValid = false;
			} else { isValid = true; }
			
			return isValid;
		}
		
		function phoneIsValid(phone) {
			var isValid = false;
			var numOnlyPattern = /[^0-9]/g;
			var valPhone = String(phone);
			var numOnlyPh = valPhone.replace(numOnlyPattern,'');
			
			if (String(numOnlyPh).length == 10) { return true; }
			
			return isValid;
		}		
	
	}
})();    
(function () {
    'use strict';
 
	angular
        .module('stats')
        .factory('timeOutService', timeOutService);

	timeOutService.$inject = ['$timeout','modalService','loginService','$state',
		'$uibModal'];//,'$log'];	

    function timeOutService($timeout, modalService, loginService, $state, 
		$uibModal) {//, $log) {
		var appTimer;
		
		var service = {
			setTimer: setTimer,
			resetTimer: resetTimer
		};
		return service;

		function setTimer(nMin) { 
			var ms = Number(nMin * 60000); //$log.info('timer set for ', ms);
			service.timer = nMin;
			appTimer = $timeout(function () {
				lastChance();			
			}, ms);			
		}
		
		/** Last Chance... modal asking if user is still there,
		  *  and wants to continue using this application.	
		  **/
		function lastChance() {
			var modalInstance = $uibModal.open({
				animation: true,
				size: 'sm',
				templateUrl: 'app/modals/modTimeout.html',
				controller: 'ModalTimeoutController',
				bindToController: true,
				controllerAs: 'modTO',
				keyboard: true,
				backdrop: 'static',
				backdropClass: 'bottom:0;height:100%;margin:0;padding-bottom:0'
			});
			modalInstance.result
			.then(function(modResult) {
				if (modResult.continue == false) {
					$state.go('login', {reload: true});
					loginService.logout();
				} else {
					service.setTimer(30);
				}
			});
		}

		function resetTimer(nMin) {
			$timeout.cancel(appTimer); //$log.info('cancelled');
			service.setTimer(nMin);

		}
	}
	
})();

(function () {
	'use strict';

	angular
		.module('stats')
		.factory('statTableService', statTableService);

	statTableService.$inject = [];

	function statTableService() {
		
		var service = {
			getStatus: getStatus
		};
		
		return service;


		function getStatus(tbl,stat) {
			var status = "";
				switch (tbl) {
					case "Table 1":
						if (stat.TABLE1SUBMITTEDDATE.indexOf('%') > 0) {
							status = stat.TABLE1SUBMITTEDDATE; }
						else if (stat.TABLE1SUBMITTEDDATE == '') {
							status = "0% Complete"; }
						else { status = "Submitted on " + stat.TABLE1SUBMITTEDDATE; }
					break;
					case "Table 2 Worksheet":
						if (stat.TABLE2WSSUBMITTEDDATE.indexOf('%') > 0) {
							status = stat.TABLE2WSSUBMITTEDDATE; }
						else if (stat.TABLE2WSSUBMITTEDDATE == '') {
							status = "0% Complete"; }
						else { status = "Submitted on " + stat.TABLE2WSSUBMITTEDDATE; }
					break;
					case "Table 2":
						if (stat.TABLE2SUBMITTEDDATE.indexOf('%') > 0) {
							status = stat.TABLE2SUBMITTEDDATE; }
						else if (stat.TABLE2SUBMITTEDDATE == '') {
							status = "0% Complete"; }
						else { status = "Submitted on " + stat.TABLE2SUBMITTEDDATE; }
					break;
					case "Table 3":
						if (stat.TABLE3SUBMITTEDDATE.indexOf('%') > 0) {
							status = stat.TABLE3SUBMITTEDDATE; }
						else if (stat.TABLE3SUBMITTEDDATE == '') {
							status = "0% Complete"; }
						else { status = "Submitted on " + stat.TABLE3SUBMITTEDDATE; }
					break;
					case "Table 4":
						if (stat.TABLE4SUBMITTEDDATE.indexOf('%') > 0) {
							status = stat.TABLE4SUBMITTEDDATE; }
						else if (stat.TABLE4SUBMITTEDDATE == '') {
							status = "0% Complete"; }
						else { status = "Submitted on " + stat.TABLE4SUBMITTEDDATE; }
					break;
					case "Table 9":
						if (stat.TABLE9SUBMITTEDDATE.indexOf('%') > 0) {
							status = stat.TABLE9SUBMITTEDDATE; }
						else if (stat.TABLE9SUBMITTEDDATE == '') {
							status = "0% Complete"; }
						else { status = "Submitted on " + stat.TABLE9SUBMITTEDDATE; }
					break;
				}	
			return status;
		}
	}
})();
(function () {
    'use strict';
 
	angular
        .module('stats')
        .factory('setCustService', setCustService);

	setCustService.$inject = ['custData','custDataDev','webSessionStorage','headerService',
		'$rootScope'];	

    function setCustService(custData, custDataDev, webSessionStorage, headerService,
		$rootScope) {
		var service = {
			fromDataSource: fromDataSource,
			fromDatabaseID: fromDatabaseID
		};
		return service;
				
		function fromDataSource(dataSource) {
			webSessionStorage.setStoredData('sDataSource', dataSource);

			if (dataSource.slice(-3) == "Dev" || dataSource == "FalconVideos") {
				for (var i=0; i<custDataDev.length; i++) {
					custData.push(custDataDev[i]);
				}
			}
			
			for (i=0; i<custData.length; i++) {
				if (custData[i].DataSource == dataSource) {
					webSessionStorage.setStoredData('sDatabaseID', custData[i].DatabaseID);
					headerService.setCustomer(custData[i].CustomerName);					
					$rootScope.$broadcast('updateCustomer');
				break; }
			}			
		}
		
		function fromDatabaseID(databaseID) {
			webSessionStorage.setStoredData('sDatabaseID', databaseID);
			
			if (databaseID.slice(-3) == "DEV" || databaseID == "VID") {
				for (var i=0; i<custDataDev.length; i++) {
					custData.push(custDataDev[i]);
				}
			}

			for (i=0; i<custData.length; i++) {
				if (custData[i].DatabaseID == databaseID) {
					webSessionStorage.setStoredData('sDataSource', custData[i].DataSource);
					headerService.setCustomer(custData[i].CustomerName);					
					$rootScope.$broadcast('updateCustomer');
				break; }
			}
		}
		
	}
})();	

(function () {
    'use strict';
 
	angular
        .module('stats')
        .factory('passwordStrength', passwordStrength);

    function passwordStrength() {
		var reLowerCase = new RegExp(/([a-z]+)/);
		var reUpperCase = new RegExp(/([A-Z]+)/);
		var reNumber = new RegExp(/([0-9]+)/);
		var reSymbol = new RegExp(/(\W+)/);
		
		var factory = {
			getPWStrength: getPWStrength
		};
		
		return factory;
		
		function getPWStrength(sPassword) {
			var iStrength = 0;
			var sPasswordStrength = "Too Short";
			var sPWClass = "tooShort";
			if (sPassword.length > 8) {
				iStrength++;
				if ((sPassword.search(reLowerCase) != -1) && 
					(sPassword.search(reUpperCase) != -1)) {
						iStrength++;
				}
				if (sPassword.search(reNumber) != -1) {
					iStrength++;
				}
				if (sPassword.search(reSymbol) != -1) {
					iStrength++;
				}
				if (sPassword.length > 11) {
					iStrength++;
				}
				
				switch (iStrength) {
					case 0: 
						sPasswordStrength = "Too Short";
						sPWClass = "tooShort";
					break;
					case 1: 
						sPasswordStrength = "Very Weak";
						sPWClass = "veryWeak";					
					break;
					case 2: 
						sPasswordStrength = "Weak";
						sPWClass = "weak";
					break;
					case 3: 
						sPasswordStrength = "Fair";
						sPWClass = "fair";					
					break;
					case 4: 
						sPasswordStrength = "Strong";
						sPWClass = "strong";					
					break;
					case 5: 
						sPasswordStrength = "Very Strong";
						sPWClass = "veryStrong";					
					break;
				}
			}
			
			return {
				strength: sPasswordStrength,
				class: sPWClass
			}
			
		}
	}
	
})();    
(function(){
    'use strict';

    angular
		.module('stats')
		.factory('modalService', modalService);

	modalService.$inject = ['$uibModal','$window','$log'];

	function modalService($uibModal, $window, $log) {
$log.info("modalService");
		
		var factory = {
            okAlert: openOKAlert,
            okPrintAlert: openPrintAlert,
            resultAlert: openResultAlert
		};
		return factory;
		
		//customize more if need larger...
		function openOKAlert(title, alertMsg) {
			$uibModal.open({
				animation: true,
				size: 'sm',
				templateUrl: 'app/modals/modAlert.html',
				controller: 'ModalController',
				bindToController: true,
				controllerAs: 'vmMod',
				keyboard: true,
				backdrop: 'static',
				backdropClass: 'bottom:0;height:100%;margin:0;padding-bottom:0',
				resolve: {
					modType: function() {
						return "OK";
					},
					title: function() {
						return title;
					},
					alertMsg: function() {
						return alertMsg;
					}	
				}
			});
		}
		
		function openPrintAlert(title, alertMsg, rptURL) {
			var modalInstance = $uibModal.open({
				animation: true,
				size: 'sm',
				templateUrl: 'app/modals/modAlert.html',
				controller: 'ModalController',
				bindToController: true,
				controllerAs: 'vmMod',
				keyboard: true,
				backdrop: 'static',
				backdropClass: 'bottom:0;height:100%;margin:0;padding-bottom:0',
				resolve: {
					modType: function() {
						return "print";
					},
					title: function() {
						return title;
					},
					alertMsg: function() {
						return alertMsg;
					}	
				}
			});
			
			modalInstance.result
			.then(function(modResult) { $log.info("OK clicked", modResult)
				if (modResult.open == true) {
					$window.open(rptURL, '_blank')
				}
			});
		}
		
		function openResultAlert(sz,result) { //sz:"sm","lg";
			$uibModal.open({
				animation: true,
				size: sz,
				templateUrl: 'app/modals/modAlert.html',
				controller: 'ModalController',
				bindToController: true,
				controllerAs: 'vmMod',
				keyboard: true,
				backdrop: true,
				backdropClass: 'bottom:0;height:100%;margin:0;padding-bottom:0',
				resolve: {
					title: function() {						
						return result[0].RESULT;
					},
					alertMsg: function() {
						return result[0].RESULTREASON;
					}
				}
			});
		}
	
	}		
})();	
(function() {
/**
 * Created by jacob on 6/17/14.
 * SecUserLoginFunctions consolidates SecUserLogin, SecGetReturnCode and UserGetChurchFunctions (which
 * 		doesn’t apply to all apps, so probably should add a parameter to skip it when not needed)
 */
    'use strict';

    angular
		.module('stats')
		.factory('loginService', loginService);

	loginService.$inject = ['$http','webSessionStorage','$rootScope','modalService',
		'authServiceCFC','mcWebCFC','custData','$state','setCustService','statsURL'];

	function loginService($http, webSessionStorage, $rootScope, modalService,
		authServiceCFC, mcWebCFC, custData, $state, setCustService, statsURL) {

		var sDataSource = "";
		
		var factory = {
            user: {
				USERID: 0,
				USERNAME: '',
				loggedIn: false,
				RETURNCODE: "",
				UserChurchFNs: []
			},
            login: login,
            logout: logout,
            secDeleteReturnCode: secDeleteReturnCode,
            secGetReturnCode: secGetReturnCode,
            secPasswordReset: secPasswordReset,
            secReturnLogin: secReturnLogin,
			usersSave: usersSave
		};
		return factory;
		
	/* Runs SecUserLogin, SecGetReturnCode, UserGetChurchFunctions (sFn) */	
		function login(username, password) {
			sDataSource = webSessionStorage.getStoredData('sDataSource');
			var params = {
				method : "SecUserLoginFunctions",
				sDataSource: sDataSource,
				sUserName: username,
				sPassword: password,
				sApp: "WebStats_2.0",
				iMinutes: 30,
				sFn: "Statistics"
			};
			return $http.post(authServiceCFC, params)
			.then(function(results) { // $log.info(results)
				if(results.data[0].SECUSERLOGIN[0].RESULT == "Success") { 
					setUserInfo(results);
				}
				return results.data;
			});
		}

		function logout() {
			var params = {
				method: "SecDeleteReturnCode",
				sDataSource: sDataSource,
				sReturnCode: factory.user.RETURNCODE
			};
			return $http.post(authServiceCFC, params)
			.then(function(results) {
				if (results.data[0].RESULTS == 'Delete Successful') {
					factory.user.RETURNCODE = "";
				}
				factory.user.loggedIn = false;
				factory.user.USERID = 0;
				factory.user.USERNAME = '';
				factory.user.UserChurchFNs = [];
				$rootScope.myApps = [];		
			});
		}
		
		function secDeleteReturnCode(retCode) {
			var params = {
				method: "SecDeleteReturnCode",
				sReturnCode: retCode
			};
			return $http.post(mcWebCFC, params)
			.then(function(results) {
				return results.data;
			});
		}

	/** Used from NavBarCtrl to Get returnCode just to transfer to
	  *	 different app... then SecUserLoginFunctions is run again from new
	  *	 app to set a new ReturnCode to 30 minutes.
	  *  iMin=1, sFn=[app to load]  
	  **/	
		function secGetReturnCode(iMin,sFn) {
			var params = {
				method: "SecGetReturnCode",
				sDataSource: sDataSource,
				iUserID: factory.user.USERID,
				sApp: "Statistics",
				iMinutes: iMin,
				sFn: sFn,
				sParams: ""
			};
			return $http.post(authServiceCFC, params)
			.then(function(results) {
				if (results.data.length > 0) {
					factory.user.RETURNCODE = results.data[0].RETURNCODE;
				}
				return results.data
			});
		}

		
	/** New Procedure for handling forgotten password, to allow a reset
	 *		after a link is sent to the UserAccount Email.	
	  */		
		function secPasswordReset(username) {
			sDataSource = webSessionStorage.getStoredData('sDataSource');
			var params = {
				method: "SecPasswordReset",
				sDataSource: sDataSource,
				sUserName: username,
				sApp: 'Statistics',
				iMinutes: 30,
				sFn: 'Statistics',
				sParams: 'PasswordReset',
				sUrl: statsURL
			};
			return $http.post(authServiceCFC, params)
			.then(function(results) {
				return results.data;
			});
		}


	/** UNABLE TO USE secReturnLogin from AuthService.cfc
	  *  App opened by passing permission from other app...
	  *	 Store DatabaseID & FN=$rootScope.goToApp to open.
	  *	 Then call regular login with ReturnCode's USERNAME/PASSWORD.
	  *	 Fields returned with SecReturnLogin(ReturnCode):
	  *	 (USERNAME, DATABASEID(sDataSource), APP, FN, USERID, PASSWORD, PARAMS) 
	  **/	
        function secReturnLogin(sReturnCode) {
            var params = {
                method: "SecReturnLogin",
                sReturnCode: sReturnCode
            };
            return $http.post(mcWebCFC, params)
            .then(function (results) {
				try {
					if (results.data[0].DATABASEID != "") {
						sDataSource = results.data[0].DATABASEID;
						factory.user.USERID = results.data[0].USERID;
						factory.user.USERNAME = results.data[0].USERNAME;
					}
					secDeleteReturnCode(sReturnCode);
				}
				catch (err) {
				//"TypeError: Cannot read property 'USERID' of undefined"	
					modalService.okAlert("Error", err);
				}	
				return results.data;
			});
		}
        
        
		function usersSave(saveStr) {
			sDataSource = webSessionStorage.getStoredData('sDataSource');
			var params = {
				method: "UsersSave",
				sDataSource: sDataSource,
				sRawDataString: saveStr
			};
			return $http.post(mcWebCFC, params)
            .then(function(results) {
				return results.data;
			});
 		}


/* Internal Utilities: */        
		
		function setUserInfo (results) {
			//Return from Login when No Conf, but one matching Username/password:
			if (results.data[0].SDATASOURCE != sDataSource) {
				setCustService.fromDataSource(results.data[0].SDATASOURCE);			
			}

			factory.user = results.data[0].SECUSERLOGIN[0];
			factory.user.RETURNCODE = results.data[0].SECGETRETURNCODE[0].RETURNCODE;
			//used if refresh browser:
			webSessionStorage.setStoredData('sReturnCode', factory.user.RETURNCODE);
			
			factory.user.loggedIn = true;
			if (results.data[0].USERGETCHURCHFUNCTIONS.length > 0) {
				factory.user.UserChurchFNs = (results.data[0].USERGETCHURCHFUNCTIONS); 
			} else { 
				factory.user.UserChurchFNs = [];
			}
			$rootScope.$broadcast('updateNav'); 
		}
		
	}
})();
(function () {
	'use strict';
 
	angular
		.module('stats')
		.factory('helpDeskService', helpDeskService);

	helpDeskService.$inject = ['$http','$sce','mcWebCFC','webSessionStorage','$rootScope',
		'version','loginService','modalService','$state'];

	function helpDeskService($http, $sce, mcWebCFC, webSessionStorage, $rootScope,
		version, loginService, modalService, $state) {
		var sDataSource = webSessionStorage.getStoredData('sDataSource');
		
		var service = {
			helpHdInitiateIssue: helpHdInitiateIssue,
			helpHdSaveIssue: helpHdSaveIssue
		};
		return service;
		
		function helpHdInitiateIssue() {
			var params = {
				method: "HelpHdInitiateIssue",
				sReturnType: "json"
			};
			return $http.post(mcWebCFC, params)
			.then(function(results) {
				return (results.data);
			});
		}
		
		function helpHdSaveIssue(id, name, email, sProb) {
			if (loginService.user.USERID > 0) {
				var UserID = loginService.user.USERID;
			} else { UserID = -1 }
			var params = {
				method: "HelpHdSaveIssue",
				iIssueID: id,
				sDataSource: sDataSource,
				sApp: "WebStatistics",
				sForm: $rootScope.sCurForm,
				sVersion: version,
				iUserID: UserID,
				sUserFullName: name,
				sUserEmail: email,
				sDatabaseID: webSessionStorage.getStoredData('sDatabaseID'),
				sProblem: sProb
			};
			return $http.post(mcWebCFC, params)
			.then(function(results) {
				if (results.data == "true") {
					$state.go($rootScope.sCurForm);
					modalService.okAlert("Success",
						"Your Help Desk issue has been sent successfully.");
				}
			});
		}
				
	}
	
})();
		

(function () {
	'use strict';
 
	angular
		.module('stats')
		.factory('headerService', headerService);
		
	headerService.$inject = ['$rootScope'];
	
	function headerService($rootScope) {
		var headerIcon = { 
			image: "images/MCicon32.png",
			alt: "MissionConnect"};
		
		var service = {
			customer: {name: "MissionConnect"},
			setCustomer: setCustomer,
			getHeaderIcon: getHeaderIcon
		};
		
		return service;
		
		function setCustomer(custName) {
			service.customer.name = custName;
			if (service.customer.name == "MissionConnect") {
				headerIcon = {
					image: "assets/images/MCicon32.png",
					alt: "MissionConnect"
				};
			} else {
				headerIcon = {
					image: "assets/images/crossflameRW_48px.png",
					alt: "UMC Cross and Flame"
				};
			}
			$rootScope.$broadcast('updateCustomer');
		}
		
		function getHeaderIcon() {
			switch (service.customer.name) {
				case "MissionConnect":
					headerIcon = {
						image: "assets/images/MCicon32.png",
						alt: "MissionConnect"
					};
				break;
				default:
					headerIcon = {
						image: "assets/images/crossflameRW_48px.png",
						alt: "UMC Cross and Flame"
					};
				break;
			}
			return headerIcon;
		}		
	}

})();
(function () {
    'use strict';

	angular
		.module('stats')
		.factory('formatterService', formatterService);

	formatterService.$inject = ['modalService'];

	function formatterService(modalService) {
		var service = {
			addThousandsCommas: addThousandsCommas,
			digitsOnly: digitsOnly,
			formatPhone: formatPhone,
			formatSSN: formatSSN,
			formatZip: formatZip
		};

		return service;

		function addThousandsCommas(numStr) {
			var pattern = /(\d+)(\d{3})/;
			numStr = numStr.toString();
			while (pattern.test(numStr)) {
				numStr = numStr.replace(pattern, '$1' + ',' + '$2');
			}
			return numStr;
		}
		
		//Remove all but Digits 0-9
		function digitsOnly(numStr) { //$log.info("formatterSvc/digitsOnly numStr:",numStr);
			var pattern = /\D/g;
			var str = numStr.toString();
			var newString = str.replace(pattern,'');
			return newString;
		}
		
		//formats AS digits entered if called with each change
		function formatPhone(phStr) {
			var pattern = /\D/g;
			var numOnly = phStr.toString().trim().replace(pattern,'');
			var tel = "";
			switch (numOnly.length) {
				case 1: case 2:
					tel = "(" + numOnly;
				break;	
				case 3:
					tel = "(" + numOnly + ") ";
				break;
				case 4: case 5:
					tel = "(" + numOnly.substr(0,3) + ") " + 
						numOnly.slice(3);
				break;
				case 6:
					tel = "(" + numOnly.substr(0,3) + ") " + 
						numOnly.slice(3) + "-";
				break;
				case 7: case 8: case 9: case 10:
					tel = "(" + numOnly.substr(0,3) + ") " + 
						numOnly.substr(3,3) + "-" + numOnly.slice(6);
				break;
				default:
					tel = "(" + numOnly.substr(0,3) + ") " + 
						numOnly.substr(3,3) + "-" + numOnly.substr(6,4);
				break;	
			}
			return tel;		//(111) 222-3333
		}
		
		function formatSSN(SSN) {
			var frmSSN = "";
			frmSSN = SSN.substr(0,3) + "-" + SSN.substr(3,2) + "-" +
				SSN.substr(5,4);
			return frmSSN;	//123456789 ==> 123-45-6789
		}
		
		function formatZip(zip) {
			var pattern = /\D/g;
			var frmZIP = "";
			var numStr = String(zip);
			var numOnly = numStr.trim().replace(pattern,'');
			switch (numStr.length) {
				case 1: case 2: case 3: case 4: case 5:
					frmZIP = String(numOnly);
				break;
				case 6: 
					if (String(numOnly).length == 5) {
						frmZIP = String(numOnly) + "-";
					} else {
						frmZIP = String(numOnly).substr(0,5) + "-" + String(numOnly).slice(5); 
					}
				break;
				case 7: case 8: case 9: case 10:
					frmZIP = String(numOnly).substr(0,5) + "-" + String(numOnly).slice(5);
				break;
				default:
					frmZIP = String(numOnly).substr(0,5) + "-" + String(numOnly).slice(5);
					if (frmZIP.length > 10) {
						modalService.okAlert("Invalid Entry",
							"A Zipcode consists of 5 digits or 9 digits. Please " +
							"enter a valid Zipcode before continuing.");
					}
				break;
			}
			return frmZIP;
		}
		
	}
})();
(function () {
    'use strict';
 
	angular
        .module('stats')
        .factory('errorEmailNotification', errorEmailNotification);

	errorEmailNotification.$inject = ['webSessionStorage','$rootScope','loginService'];

    function errorEmailNotification(webSessionStorage, $rootScope, loginService) {
		var sDataSource = webSessionStorage.getStoredData("sDataSource");
		var sEmailContent = "";
		
		var factory = {
			error1: error1,
			error2: error2,
			error3: error3,
			error4: error4,
			error5: error5,
			errorMoodle: errorMoodle
		};
		return factory;
		
		
		function error1(sFormProc) {
			sEmailContent = "Error in " + sFormProc + "()<br><br>" +
				"DataSource: " + sDataSource + "<br>" +
				"ReturnCode: " + $rootScope.retCodeKey + "<br>" +
				"User: " + loginService.user.USERFULLNAME + "<br>" +
				"UserID: " + loginService.user.USERID;
			return sEmailContent;
		}
		
		function error2(sFormProc) {
			sEmailContent = "Error in " + sFormProc + "()<br><br>" +
				"DataSource: " + sDataSource + "<br>" +
				"ProID: " + $rootScope.sProID + "<br>" +
				"Applicant: " + $rootScope.Applicant + "<br>" +
				"User: " + loginService.user.USERFULLNAME + "<br>" +
				"UserID: " + loginService.user.USERID;
			return sEmailContent;
		}
		
		function error3(sFormProc, iSaveKey) {
			sEmailContent = "Error in " + sFormProc + "()<br><br>" +
				"DataSource: " + sDataSource + "<br>" +
				"ProID: " + $rootScope.sProID + "<br>" +
				"Applicant: " + $rootScope.Applicant + "<br>" +
				"StepSaveKey: " + String(iSaveKey) + "<br>" +
				"User: " + loginService.user.USERFULLNAME + "<br>" +
				"UserID: " + loginService.user.USERID;
			return sEmailContent;
		}
		
		function error4(sFormProc) {
			sEmailContent = "Error in " + sFormProc + "()<br><br>" +
				"DataSource: " + sDataSource + "<br>" +
				"ProID: " + $rootScope.sProID + "<br>" +
				"User: " + loginService.user.USERFULLNAME + "<br>" +
				"UserID: " + loginService.user.USERID;
			return sEmailContent;
		}
		
		function error5(sForm, emailContent) {
			sEmailContent = "Error in " + sForm + "<br>" +
				emailContent + "<br><br>" +
				"DataSource: " + sDataSource + "<br>" +
				"ProID: " + $rootScope.sProID + "<br>" +
				"User: " + loginService.user.USERFULLNAME + "<br>" +
				"UserID: " + loginService.user.USERID;
			return sEmailContent; 
		}
		
		function errorMoodle(mReturn,proc) {
			sEmailContent = "Error in WebApps_Pro/" + proc + "()<br><br>" +
				"User not found, and not created. Run test in WebProtect_AIR for:<br> " +
				"ProID: " + $rootScope.sProID + "<br>" +
				"User: " + loginService.user.USERFULLNAME + "<br>" +
				"UserID: " + loginService.user.USERID + "<br><br>" +
				"Returned from Moodle: " + mReturn;
			return sEmailContent;	
		}
	}

})();
(function () {
    'use strict';
 
	angular
        .module('stats')
        .factory('emailValidator', emailValidator);

    function emailValidator() {
		var factory = {
			isValid: isValid
		};
		
		return factory;
		
		function isValid(sEmail) {
			var filter = new RegExp(/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/);

			if (sEmail.search(filter) == -1) {
				return false;
			} else {
				return true;
			}
		}		
	}

})();    
(function () {
	'use strict';

	angular
		.module('stats')
		.factory('datesService', datesService);

	datesService.$inject = ['$log'];

	function datesService($log) {

		var service = {
			calStrToDbDateStr: calStrToDbDateStr,
			currentYear: currentYear,
			get19thBirthDate: get19thBirthDate,
			jsDateStrToCalendarStr: jsDateStrToCalendarStr,
			jsDateStrToDbDateStr: jsDateStrToDbDateStr,
			nowAsCalStringPlusTime: nowAsCalStringPlusTime,
			nowAsDbDatePlusTime: nowAsDbDatePlusTime,
			s1yrFromToday: s1yrFromToday,
			s6mosFromToday: s6mosFromToday,
			s15mosFromToday: s15mosFromToday,
			todayToCalString: todayToCalString,
			todayToDbString: todayToDbString
		};
		return service;
		
		function calStrToDbDateStr(sCal) {
			var dCal = new Date(sCal);
			var mm = dCal.getMonth()+1;
			if (mm < 10) { mm = "0" + String(mm); }
			var dd = dCal.getDate();
			if (dd < 10) { dd = "0" + String(dd); }
			var sDbDate = String(dCal.getFullYear()) + "-" + mm + "-" + dd;
			return sDbDate;			// "01/01/2017" ==> "2017-01-01"
		}

		function currentYear() {
			var today = new Date();
			var yr = today.getFullYear();
			return yr; //2017	
		}
		
		function get19thBirthDate(bDay) { // 19th BirthDate as MM/DD/YYYY
			var s19thBDay = "";
			var dt = new Date(bDay);
			var mm = dt.getMonth()+1;
			if (mm < 10) { mm = "0" + String(mm); }
			var dd = dt.getDate();
			if (dd < 10) { dd = "0" + String(dd); }
			s19thBDay = mm + "/" +  dd + "/" + String(dt.getFullYear()+19);
			return s19thBDay;
		}

		function jsDateStrToCalendarStr(dtStr) {
			var sCalDate = "";
			var dt = new Date(dtStr);
			var mm = dt.getMonth()+1;
			if (mm < 10) { mm = "0" + String(mm); }
			var dd = dt.getDate();
			if (dd < 10) { dd = "0" + String(dd); }
			sCalDate = mm + "/" + dd + "/" + String(dt.getFullYear()) ;
			return sCalDate; // "August 03, 2017 17:50:20" ==> "08/03/2017"
		}

		function jsDateStrToDbDateStr(dtStr) {
			var sDbDate = "";
			var dt = new Date(dtStr);
			var mm = dt.getMonth()+1;
			var dd = dt.getDate();
			sDbDate = dt.getFullYear() + "-" + mm +	"-" + dd;
			return sDbDate; // // "August 03, 2017 17:50:20" ==> "2017-08-03"
		}
		
		function nowAsCalStringPlusTime() {
			var today = new Date(); $log.info("today",today)
			var mm = today.getMonth()+1;
			var dd = today.getDate();
			var sCalToday = mm + "/" + dd + "/" + String(today.getFullYear()) + " " +
				today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds() +
				"." + today.getMilliseconds();
			return sCalToday;	// today as "MM/DD/YYYY HH:MM:SS.MS"
		}
		
		function nowAsDbDatePlusTime() {
			var today = new Date(); $log.info("today",today)
			var mm = today.getMonth()+1;
			var dd = today.getDate();
			var sToday = String(today.getFullYear()) + "-" + mm + "-" + dd + " " + 
				today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds() +
				"." + today.getMilliseconds();
			return sToday;	// today as "YYYY-MM-DD HH:MM:SS.MS"
		}
		
		function s1yrFromToday() {
			var today = new Date();
			var mm = today.getMonth()+1;
			var dd = today.getDate();
			if (dd < 10) { dd = "0" + String(dd); }
			var sCalDate = mm + "/" + dd + "/" + String(today.getFullYear()+1);
			return sCalDate; // today in 2017 as "MM/DD/2018"
		}
		
		function s6mosFromToday() {
			var today = new Date();
			var mm = today.getMonth()+1;
			var dd = today.getDate();
			if (dd < 10) { dd = "0" + String(dd); }
			var yr = today.getFullYear();
			var sCalDate = "";
			if (mm < 7) { sCalDate = String(mm+6) + "/" + dd + "/" + yr; }
			else { sCalDate = String((mm+6)-12) + "/" + dd + "/" + String(yr+1); }
			return sCalDate; // today= 7/1/2017 ==> "01/01/2018"
		}
		
		function s15mosFromToday() {
			var today = new Date();
			var mm = today.getMonth()+1;
			var dd = today.getDate();
			if (dd < 10) { dd = "0" + String(dd); }
			var yr = Number(today.getFullYear())+1;
			var sCalDate = "";
			if (mm < 10) { sCalDate = String(mm+3) + "/" + dd + "/" + yr; }
			else { sCalDate = String((mm+3)-12) + "/" + dd + "/" + String(yr+1); }
			return sCalDate; // today= 10/1/2017 ==> "01/01/2019"
		}
		
		function todayToCalString() {
			var today = new Date();
			var mm = today.getMonth()+1;
			var dd = today.getDate();
			var sCalToday = mm + "/" + dd + "/" + String(today.getFullYear()) ;
			return sCalToday;	// today as "MM/DD/YYYY"
		}
		
		function todayToDbString() {
			var today = new Date();
			var mm = today.getMonth()+1;
			var dd = today.getDate();
			var sDbToday = String(today.getFullYear()) + "-" + mm + "-" + dd;
			return sDbToday;	// today as "YYYY-MM-DD"
		}

	}
})();
/** UPDATES:
  *		01/15/19 lds - removed ReturnCodeReset function and all calls to it, as timeOutService now 
  *			handling internally.
  **/

(function () {
    'use strict';
 
	angular
        .module('stats')
        .factory('dataService', dataService);

	dataService.$inject = ['$http','$sce','webSessionStorage','loginService','$rootScope','statsCFC'];	

    function dataService($http, $sce, webSessionStorage, loginService, $rootScope, statsCFC) {
		var sDataSource = "";

		var service = {
			setDataSource: setDataSource,
			emailSendCustom: emailSendCustom,
			fxGet: fxGet,
			libLoadList: libLoadList,
			rptStatChurch: rptStatChurch,
			sendForgottenPassword: sendForgottenPassword,
			statGetCompleted: statGetCompleted,
			statGetForm: statGetForm,
			statGetFormData: statGetFormData,
			statGetFormStatus: statGetFormStatus,
			statGetTables: statGetTables,
			statSaveCompleted: statSaveCompleted,
			statSaveStatData: statSaveStatData,
			usersChangePassword: usersChangePassword,
			userGetChurchFunctions: userGetChurchFunctions
		};
		return service;

		function setDataSource() {
			sDataSource = webSessionStorage.getStoredData('sDataSource');
		}
		
		function emailSendCustom(sEmailAddr, sFrom, sReplyTo, sSubject, sEmailContent) {
            var params = {
                method: "EmailSendCustom",
                sEmailAddr: sEmailAddr,
                sFrom: sFrom,
                sReplyTo: sReplyTo,
                sSubject: sSubject,
                sEmailContent: sEmailContent
            };
            return $http.post(statsCFC, params)
            .then(function (results) {
                return results.data;
            });
		}
		
		function fxGet(form) {
			var params = {
				method: "FxGet",
				sDataSource: sDataSource,
				sApp: "WebStatistics",
				sForm: form,
				sSpecifier: "X"	
			};
			return $http.post(statsCFC, params)
            .then(function (results) {
                return results.data;
            });
		}
		
		function libLoadList() {
			if (sDataSource == "") { setDataSource(); }
			var params = {
				method: "LibLoadList",
				sDataSource: sDataSource
			};
			return $http.post(statsCFC, params)
            .then(function (results) {
				return results.data;
            });
		}
		
		function rptStatChurch(sTables, year, chID, prevYr) {
			var params = {
				method: "RptStatChurch",
				sDataSource: sDataSource,
				iUserID: loginService.user.USERID,
				sFormName: sTables,
				sYear: year,
				iEntityID: chID,
				bIncludePrevYear: prevYr
			};
			return $http.post(statsCFC, params)
            .then(function (results) {
				return results.data;
            });
		}
		
		function sendForgottenPassword(sUserName) {
			var params = {
				method: "SendForgottenPassword",
				sDataSource: sDataSource,
                sUserName: sUserName,
                sCustomEmailText: ""
            };
            return $http.post(statsCFC, params)
            .then(function (results) {
                return results.data;
            });
		}
		
		function statGetCompleted(id, year, form) {
			var params = {
				method: "StatGetCompleted",
				sDataSource: sDataSource,
				iEntityID: id,
				sYear: year,
				sFormName: form
			};
			return $http.post(statsCFC, params)
            .then(function (results) {
                return results.data;
            });

		}
		
		function statGetForm(year) {
			var params = {
				method: "StatGetForm",
				sDataSource: sDataSource,
				sFormName: "all",
				sYear: year
			};
			return $http.post(statsCFC, params)
            .then(function (results) {
                return results.data;
            });
		}
		
		function statGetFormData(year, entityID) {
			var params = {
				method: "StatGetFormData",
				sDataSource: sDataSource,
				sFormName: "all",
				sYear: year,
				iEntityID: entityID
			};
			return $http.post(statsCFC, params)
            .then(function (results) {
                return results.data;
            });
		}
		
		function statGetFormStatus(entityID, yr) {
			if (sDataSource == "") { setDataSource(); }
			var params = {
				method: "StatGetFormStatus",
				sDataSource: sDataSource,
				iEntityID: entityID,
				sYear: yr	
			};
			return $http.post(statsCFC, params)
            .then(function (results) {
                return results.data;
            });
		}
		
		function statGetTables(year) {
			var params = {
				method: "StatGetTables",
				sDataSource: sDataSource,
				sYear: year	
			};
			return $http.post(statsCFC, params)
            .then(function (results) {
                return results.data;
            });
		}
		
		function statSaveCompleted(sSaveString) {
			var params = {
				method: "StatSaveCompleted",
				sDataSource: sDataSource,
				sRawDataString: sSaveString
			};
			return $http.post(statsCFC, params)
            .then(function (results) {
// 				resetReturnCode();
                return results.data;
            });

		}
		
		function statSaveStatData(sSaveString) {
			var params = {
				method: "StatSaveStatData",
				sDataSource: sDataSource,
				sRawDataString: sSaveString
			};
			return $http.post(statsCFC, params)
            .then(function (results) {
// 				resetReturnCode();
                return results.data;
            });

		}
    
    //Preset to ONLY For pulling MENU applications:
		function userGetChurchFunctions() {
			if (sDataSource == "") { setDataSource(); }
			var params = {
				method: "UserGetChurchFunctions",
				sDataSource: sDataSource,
				iUserID: loginService.user.USERID,
				sFn: "all",
				bFnOnly: 1	
			};
			return $http.post(statsCFC, params)
            .then(function (results) {
                return results.data;
            });
		}
		
		function usersChangePassword(sSaveString) {
			var params = {
				method: "UsersChangePassword",
				sDataSource: sDataSource,
				sRawDataString: sSaveString
			};
			return $http.post(statsCFC, params)
			.then(function (results) {
				return results.data;
			});
		}
		

		
//Internally called functions:
		
	
/*	Deprecated 01/15/19 with release of timeOutService:
		function resetReturnCode() {
			loginService.secReturnReset(loginService.user.RETURNCODE, loginService.user.USERID, 30)
			.then(function(result) {
				$log.info("Reset ReturnCode:",result[0].RESULT);
				return result.RESULT;
			});
		}
*/
		
    }
 })(); 
 
(function () {
    'use strict';
 
	angular
        .module('stats')
        .factory('confirmPWChg', confirmPWChg);

    function confirmPWChg() {
		var factory = {
			confirmEmail: confirmEmail,
			confirmPassword: confirmPassword,
			notReadyToSave: notReadyToSave
		};
		return factory;
		
		function confirmEmail(sNewEmail, sConfirmEmail) {
			var strEmail;
			if (sNewEmail != "" && sConfirmEmail != "") {
				if (sNewEmail.toLowerCase() == sConfirmEmail.toLowerCase()) {
					strEmail = "true"; }
				else {
					strEmail = "The New Email and the Confirmed Email addresses do not match. " +
						"Please enter the Email addresses again."; 
				}
			} else {
				strEmail = "false";
			}
			return strEmail;
		}
				
		function confirmPassword(sNewPW, sConfirmPW) {
			var strPW;
			if (sNewPW != "" && sConfirmPW != "") {
				if (sNewPW == sConfirmPW) { strPW = "true"; }
				else {
					strPW = "The New Password and the Confirmed Password do not match. " +
						"Please enter the passwords again."; 
				}
			} else {
				strPW = "false";
			}
			return strPW;
		}
		
		//click Save button when NOT activated, so tell user why...
		function notReadyToSave(sOldPW, sNewPW, sConfirmPW, sNewEmail, sConfirmEmail) {
			var str = "";
			if (sOldPW == "" && sNewPW == sConfirmPW) {
				str = "It is required that you enter your old password " +
					"in order to Save a new one."; }
			else if ((sNewEmail != "" || sConfirmEmail != "") &&
				sNewEmail.length != sConfirmEmail.length) {
				str = "You must enter the new Email Address twice, and the " +
					"entries must match, in order to save a new Email.\n\n" +
					"Please be sure you are entering the same address in " +
					"both the New and Confirm Email Address fields."; }
			else if ((sNewPW != "" || sConfirmPW != "") &&
				sNewPW.length != sConfirmPW.length) {
				str = "You must enter the new Password twice, and the \n" +
					"entries must match, in order to save a new Password.\n\n" +
					"Please be sure you are entering the same password in " +
					"both the New and Confirm Password fields."; }	
			else if (sOldPW == "" && sNewPW == "" && sConfirmPW == "" &&
				sNewEmail == "" && sConfirmEmail == "") {
				str = "There is nothing to Save! \n\n" +
					"Please enter your new Password or Email before " +
					"clicking the Save button.";	
			}
			return str;
		}
	}

})();
(function () {
	'use strict';

	angular
		.module('stats')
		.factory('checkSumsService', checkSumsService);

	function checkSumsService() {

		var service = {
			readyToSubmit: {
				Table1: false,
				Table2Ws: false,
				Table2: false,
				Table3: false,
				Table4: false,
				Table9: false
			}
		};
		return service;
		
	}
})();

(function () {
    'use strict';
 
	angular
        .module('stats')
        .factory('appValidationService', appValidationService);

	appValidationService.$inject = ['loginService','modalService'];	

    function appValidationService(loginService, modalService) {
		var service = {
			validateAccess: validateAccess
		};
		
		return service;
		
		function validateAccess() {
			var apps = loginService.user.UserChurchFNs;
			var perm = "Denied";
			if (apps.length > 0) {
				for (var i=0; i<apps.length; i++) { 
					if (apps[i].FN == "Statistics") {
						perm = "Valid";
					break; }
					else if (i == apps.length-1) {
						modalService.okAlert("Account Access Denied",
							"This user account is not authorized to use the online Statistics " +
							"application. Authorized applications for this user account " +
							"will be listed in the MENU.");
					}		
				}	
			} else {
				modalService.okAlert("Account Access Denied", 
					"This account does not have access to any MissionConnect online " +
					"applications at this time.<br><br>Please contact your Conference " +
					"Administrator to request access.");
			}
			
			return perm; //Valid, Denied	
		}	
	}
})();
(function() {
	'use strict';

	angular
		.module('stats')
		.config(function($httpProvider) {
		$httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';

			// Override $http service's default transformRequest 
			$httpProvider.defaults.transformRequest = [function(data) {
				/* The workhorse; converts an object to x-www-form-urlencoded serialization. * @param {Object} obj * @return {String} */ 
				var param = function(obj) { 
					var query = ''; 
					var name, value, fullSubName, subName, subValue, innerObj, i; 
					for(name in obj) { 
						value = obj[name]; 
						if(value instanceof Array) { 
							for(i=0; i<value.length; ++i) { 
								subValue = value[i]; 
								fullSubName = name + '[' + i + ']'; 
								innerObj = {}; 
								innerObj[fullSubName] = subValue; 
								query += param(innerObj) + '&'; 
							} 
						} 
						else if(value instanceof Object) { 
							for(subName in value) { 
								subValue = value[subName]; 
								fullSubName = name + '[' + subName + ']'; 
								innerObj = {}; 
								innerObj[fullSubName] = subValue; 
								query += param(innerObj) + '&';
							}
						}
						else if(value !== angular.isUndefined && value !== null) {
							query += encodeURIComponent(name) + '=' + encodeURIComponent(value) + '&'; 
						}
					}
					return query.length ? query.substr(0, query.length - 1) : query;
				}; 
				return angular.isObject(data) && String(data) !== '[object File]' ? param(data) : data;
			}];
		});
})();
/* 
GLOBALS:

	sessionStorage:
		sDataSource = 	webSessionStorage.getStoredData('sDataSource');
		sDatabaseID	=	webSessionStorage.getStoredData('sDatabaseID');
		
	$rootScope:	
		
    loginServices:
		loginService.user = { 
			USEREMAIL,				==> chgPWCtrl
			USERID,					==> refCtrl, dataService
			USERFULLNAME,			==> certMgmtCtrl, refCtrl, referRefEmail
			USERENTITYID			==> certMgmtCtrl, applCtrl
			RETURNCODE				==> 
			RETURNKEY
			loggedIn
			UserChurchFNs			==> populated with USERGETCHURCHFUNCTIONS return all
										churches user has permission to access through various functions
		};            
		
		
TODO:
	* 
	
	LIVE:
		
	Development: cd Applications/ColdFusion9/wwwroot/Burt/Falcon/Web_TestSite/[appName]
	Release PATH:  MissionConnect/Public/MCWebApps/ ... /#/index.html
			
*/	
angular
	.module('stats')
	.directive('enterAsTab', enterAsTab);

enterAsTab.$inject = [];

function enterAsTab() {
	return function (scope, element, attrs) {
		element.bind("keydown keypress", function (event) {
			if (event.which === 13) {
				event.preventDefault();
				var elementToFocus = element.next('tr').find('input')[1];
				if (angular.isDefined(elementToFocus)) {
					elementToFocus.focus();
				}
			}
		});
	};
}

angular
    .module('stats')
    .controller('StatHistoryController', StatHistoryController);

StatHistoryController.$inject = ['$rootScope','loginService','dataService','$state','datesService',
	'$sce','$scope','$stateParams','timeOutService','checkSumsService','$log'];

function StatHistoryController($rootScope, loginService, dataService, $state, datesService, 
	$sce, $scope, $stateParams, timeOutService, checkSumsService, $log) {
    var vm = this;
    
    vm.arrChurches = [];
    vm.arrStatRecords = [];
	vm.FNs = loginService.user.UserChurchFNs;
	vm.iChurchID = loginService.user.USERENTITYID;
	vm.sChurchName = "";
	vm.selChurch = {};
	vm.sInstructions = "";
	vm.sUsername = loginService.user.USERNAME;
//Custom Tables:	
	vm.showWS = false; 	//Show Worksheet columns... only used in LA
	vm.showTable4 = false;
	vm.showTable9 = false;

//INITIALIZE:
	$rootScope.sCurForm = "Statistical Records"
// $log.info($rootScope.sCurForm)
	$rootScope.$broadcast('closeMenu');

	//$stateParams.iChurchID only used coming BACK from StatsEntry:
	if ($stateParams.iChurchID > 0) {
		vm.iChurchID = $stateParams.iChurchID;
		vm.sChurchName = $stateParams.sChurchName;
	}

	dataService.fxGet('StatsHistory')
	.then(function(instr) {
		if (instr.length > 0) { //$log.info("formText",instr)
			vm.sInstructions = $sce.trustAsHtml(instr[0].TEXT);
		}
	});

	if (vm.FNs.length == 1 && vm.FNs[0].FN == 'Statistics') { 
		vm.sChurchName = vm.FNs[0].CHURCHNAME; //$log.info("ChurchName:",vm.sChurchName);
		populateStatsTable();
	} else {
		for (var i=0; i<vm.FNs.length; i++) {
			if (vm.FNs[i].FN == 'Statistics') {
				vm.arrChurches.push(vm.FNs[i]);
			}
		}
		if (vm.arrChurches.length == 1) {
			vm.sChurchName = vm.FNs[0].CHURCHNAME;
		}
		populateStatsTable();
	}	

	
	function populateStatsTable() {
		dataService.statGetFormStatus(vm.iChurchID, 'all')
		.then(function(stats) { $log.info("statFormStatus:",stats)
			if (stats.length>0) {
				//show additional custom tables:
				for (var i=0; i<stats.length; i++) {
					if (angular.isDefined(stats[i].TABLE2WSSTARTEDDATE)) {
						vm.showWS = true;
					} else if (angular.isDefined(stats[i].TABLE4STARTEDDATE)) {
						vm.showTable4 = true;
					} else if (angular.isDefined(stats[i].TABLE9STARTEDDATE)) {
						vm.showTable9 = true;
					}
				}
				for (i=0; i<stats.length; i++) {
					if (stats[i].TABLE1SUBMITTEDDATE == '100% Complete') {
						stats[i].readyToSubmit = checkSumsService.readyToSubmit.Table1; }
					if (stats[i].TABLE2WSSUBMITTEDDATE == '100% Complete') {
						stats[i].readyToSubmit = checkSumsService.readyToSubmit.Table2Ws; }
					if (stats[i].TABLE2SUBMITTEDDATE == '100% Complete') {
						stats[i].readyToSubmit = checkSumsService.readyToSubmit.Table2; }
					if (stats[i].TABLE3SUBMITTEDDATE == '100% Complete') {
						stats[i].readyToSubmit = checkSumsService.readyToSubmit.Table3; }
					if (stats[i].TABLE4SUBMITTEDDATE == '100% Complete') {
						stats[i].readyToSubmit = checkSumsService.readyToSubmit.Table4; }
					if (stats[i].TABLE9SUBMITTEDDATE == '100% Complete') {
						stats[i].readyToSubmit = checkSumsService.readyToSubmit.Table9; }
				}
// $log.info('after checkSumssService:', stats);
				vm.arrStatRecords = stats; 
// $log.info('arrStatRecords:', vm.arrStatRecords);
			}
		});
	}	
	
	function submitHandler(result) {
		var sRawDataString = "WebApps_Stats || v.001 || " + loginService.user.USERID + 
			" || U || SaveKey==" + result[0].SAVEKEY + " || EntityID==" + vm.iChurchID + 
			" || FormYear==" + result[0].FORMYEAR + " || FormName==" + result[0].FORMNAME +
			" || CompletedOn==" + datesService.nowAsDbDatePlusTime() + " || CompletedBy==" +
			loginService.user.USERID + " ^^ ";

		dataService.statSaveCompleted(sRawDataString)
		.then(function(save) {
			if (save[0].RESULTCODE == 'Success') {
				populateStatsTable();
			}
		});
	}


/* Broadcasts: */
	
	
/* Calls from View: */
	vm.loadSelectedChurch = function(item) {
		timeOutService.resetTimer(30);
		vm.selChurch = item;
		vm.iChurchID = item.CHURCHID;
		populateStatsTable();
	};
	
	vm.openStat = function(stat) { //$log.info("stat:",stat)
		timeOutService.resetTimer(30);
		$state.go('statEntry', {
			sChurchName: vm.sChurchName,
			statRecord: stat
		}, {reload:true});	
	};
	
	vm.submitTable = function(stat,tbl) { // $log.info(stat,tbl)
		timeOutService.resetTimer(30);
		dataService.statGetCompleted(vm.iChurchID, stat.FORMYEAR, tbl)
		.then(function(result) { //$log.info(result)
			if (result.length > 0) {
				submitHandler(result);
			} else { 
				var sRawDataString = "WebApps_Stats || v.001 || " + loginService.user.USERID + 
					" || I || EntityID==" + vm.iChurchID + " || FormYear==" + stat.FORMYEAR + 
					" || FormName==" + tbl + " || CompletedOn==" + datesService.nowAsDbDatePlusTime() + 
					" || CompletedBy==" + loginService.user.USERID + " ^^ ";
				
				dataService.statSaveCompleted(sRawDataString)
				.then(function(save) {
					if (save[0].RESULTCODE == 'Success') {
						populateStatsTable();
					}
				});
			}
		});
	};
	
}

angular
    .module('stats')
    .controller('StatEntryController', StatEntryController);   

StatEntryController.$inject = ['dataService','$stateParams','loginService','statTableService',
	'$rootScope','$sce','formatterService','webSessionStorage','datesService','$state','modalService',
	'$window','timeOutService','checkSumsService','$log'];

function StatEntryController(dataService, $stateParams, loginService, statTableService,
	$rootScope, $sce, formatterService, webSessionStorage, datesService, $state, modalService,
	$window, timeOutService, checkSumsService, $log) {
    var vm = this;

	vm.arrCheckSums = [];
	vm.arrData = [];
	vm.arrDefs = [];
	vm.arrDataFields = [];
	vm.arrSums = [];
	vm.arrTables = [];
	vm.bChkSumsOff = false;
	vm.sChkSumsErrorTable = "";	//Store Table name for use in alert.
	vm.bSubmitted = false;	//indicates the selTable is submitted
	vm.bReadyToSave = 'false';
	vm.iChurchID = $stateParams.statRecord.ENTITYID;
	vm.sChurchName = $stateParams.sChurchName;
	vm.sDatabaseID = webSessionStorage.getStoredData('sDatabaseID');
	vm.selTable = "";
	vm.sPercentComplete = "";
	vm.prevYear = "";
	vm.sTableText = "";		//for Display (others just hold until table selected)
	vm.sTable1Text = "";
	vm.sTable2WsText = "";
	vm.sTable2Text = "";
	vm.sTable3Text = "";
	vm.sTable4Text = "";
	vm.sTable9Text = "";
	vm.statRecord = $stateParams.statRecord;
	vm.tblCell;

//INITIALIZE:
	$rootScope.sCurForm = "Stats Entry";
// $log.info($rootScope.sCurForm)	
	
	vm.prevYear = String(Number(vm.statRecord.FORMYEAR)-1);
	
	dataService.fxGet("StatsEntry")
	.then(function(formText) {
		for (var i=0; i<formText.length; i++) {
			switch (formText[i].TEXTID) {
				case "Table1_Instructions":
					vm.sTable1Text = $sce.trustAsHtml(formText[i].TEXT);
				break;
				case "Table2Ws_Instructions":
					vm.sTable2WsText = $sce.trustAsHtml(formText[i].TEXT);
				break;
				case "Table2_Instructions":
					vm.sTable2Text = $sce.trustAsHtml(formText[i].TEXT);
				break;
				case "Table3_Instructions":
					vm.sTable3Text = $sce.trustAsHtml(formText[i].TEXT);
				break;
				case "Table4_Instructions":
					vm.sTable4Text = $sce.trustAsHtml(formText[i].TEXT);
				break;
				case "Table9_Instructions":
					vm.sTable9Text = $sce.trustAsHtml(formText[i].TEXT);
				break;
			}
		}
		vm.sTableText = vm.sTable1Text;		
	});
	
	getStatTables();
	
	function getStatTables() {
		dataService.statGetTables(vm.statRecord.FORMYEAR)
		.then(function(tables) { //$log.info("tables:",tables)
			if (tables.length > 0) {
				vm.arrTables.push(tables[0]);
			//LA has Worksheet that needs to come before Table2... else, load dynamically:	
				if (tables[2].FORM == "Table 2 Worksheet") {
					vm.arrTables.push(tables[2]);
					vm.arrTables.push(tables[1]);
					for (var i=3; i<tables.length; i++) {
						vm.arrTables.push(tables[i]);
					}
				} else {
					for (i=1; i<tables.length; i++) {
						vm.arrTables.push(tables[i]);
					}
				}
				vm.selTable = vm.arrTables[0].FORM;
				
				setCompleted();
				getStatDefs();
			}
		});
	}
	
	function getStatDefs() {
		dataService.statGetForm(vm.statRecord.FORMYEAR)
		.then(function(defs) { 	//$log.info("Defs:",defs)
			if (defs.length > 0) {
				vm.arrDefs = defs;
				
				getStatData();				
			} else {
				modalService.okAlert("No Statistics Found",
					"There are no Statistics defined for this year.");
			}
		});
	}	
	
	function getStatData() {
		dataService.statGetFormData(vm.statRecord.FORMYEAR, vm.statRecord.ENTITYID)
		.then(function(data) { $log.info("Data:",data)
			if (data.length > 0) {
				vm.arrData = data;
				loadDisplay();
			}
		});
	}
	
	function loadDisplay() {
		vm.arrDataFields = [];
		vm.arrCheckSums = [];
		vm.arrSums = [];
		for (var i=0; i<vm.arrDefs.length; i++) {
			if (vm.arrDefs[i].FORM == vm.selTable) {
				var obj = {
					Ln:vm.arrDefs[i].FORMLINE, Desc1:vm.arrDefs[i].DESCRIPTIONLINE1,
					Desc2:vm.arrDefs[i].DESCRIPTIONLINE2, seq:vm.arrDefs[i].STATITEMSEQ,
					Locked:vm.arrDefs[i].DATASOURCE, ds:vm.arrDefs[i].DATASOURCE,
					data:"", prevData:"", form:vm.arrDefs[i].FORM,
					statItem:vm.arrDefs[i].STATITEM, source: vm.arrDefs[i].SOURCEDEF,					
					formGroup:vm.arrDefs[i].FORMGROUP, numDol:vm.arrDefs[i].NUMDOL
				};

				//set field backgrounds:
				if (obj.Locked == "Enter" &&
					(vm.bSubmitted == true || vm.statRecord.WEBLOCK=="Locked")) {
					obj.Locked = 'Locked';
				}
				
				//Add any existing data:
				for (var j=0; j<vm.arrData.length; j++) {
					if (vm.arrData[j].FORM == vm.selTable &&
						vm.arrData[j].STATITEM == vm.arrDefs[i].STATITEM) {
						switch (vm.arrDefs[i].NUMDOL) {
							case "Number":
							case "Dollars":
								
								obj.data = formatterService.addThousandsCommas(vm.arrData[j].CURDATA);
								obj.prevData = formatterService.addThousandsCommas(vm.arrData[j].PREVDATA);
							break;
							case "Text":
								obj.data = vm.arrData[j].CURDATA;
							break;
							case "Yes|No":
								switch (vm.arrData[j].CURDATA) {
									case 1: obj.data = "Yes"; break;
									case 0: obj.data = "No"; break;
								}
								switch (vm.arrData[j].PREVDATA) {
									case 1: obj.prevData = "Yes"; break;
									case 0: obj.prevData = "No"; break;
								}
							break;
						}
					break; }
				}
				
				//Populate Sums, CheckSums:
				switch(vm.arrDefs[i].DATASOURCE) {
					case "Enter":
						if (vm.arrDefs[i].SOURCEDEF.substr(0,8)=='Checksum') {
							var chkSum = vm.arrDefs[i].SOURCEDEF; 
// $log.info("chkSum:",vm.arrDefs[i].SOURCEDEF);
							var idx = chkSum.indexOf('>');
							vm.arrCheckSums.push({
								form:vm.arrDefs[i].FORM,
								chkSum:chkSum.substring(0,idx),
								statItem:vm.arrDefs[i].STATITEM,
								sumField:chkSum.slice(idx+1)
							});
						}
// $log.info("arrCheckSums:",vm.arrCheckSums)
					break;
					case "Sum":
						var arrCalcFields = [];
						arrCalcFields = vm.arrDefs[i].SOURCEDEF.split(',');
						if (arrCalcFields.length == 1) {
							var cMath = arrCalcFields[0].substr(0,1);
							var sStat = arrCalcFields[0].slice(1);
							for (var c=0; c<vm.arrData.length; c++) {
								if (vm.arrData[c].STATITEM == sStat) {
									if (cMath == "+") { 
										obj.data = vm.arrData[c].CURDATA; 
										obj.prevData = vm.arrData[c].PREVDATA;
									}
								break; }
							}
						} else {
							for (var k=0; k<arrCalcFields.length; k++) {
								vm.arrSums.push({
									math: arrCalcFields[k].substr(0,1),
									statItem: arrCalcFields[k].slice(1),
									sumField: vm.arrDefs[i].STATITEM
								});
							}
						}	
					break; 
				}
				vm.arrDataFields.push(obj);
			}
		} 
// $log.info("arrDataFields:",vm.arrDataFields)
		if (vm.bSubmitted == false && vm.sPercentComplete != "0% Complete") {
			runTheCheckSums();
		}
	}
	
	function refreshStatus() {
		dataService.statGetFormStatus(vm.iChurchID, vm.statRecord.FORMYEAR)
		.then(function(status) { //	$log.info("status:",status)
			if (status.length>0) {
				vm.statRecord = status[0];
				setCompleted();
			}
		});
	}

	function runTheCheckSums() {
		//to indicate any Sum fields that are not accurate before a Save...
		var sum1 = ""; var sum1Amt = 0; var sumField1 = ""; var sum1sum = 0;
		var sum2 = ""; var sum2Amt = 0; var sumField2 = ""; var sum2sum = 0;
		var sum3 = ""; var sum3Amt = 0; var sumField3 = ""; var sum3sum = 0;
		if (vm.arrCheckSums.length > 0) { 
// $log.info("checkSums:",vm.arrCheckSums)
			for (var i=0; i<vm.arrCheckSums.length; i++) {
				if (vm.arrCheckSums[i].form == vm.selTable) { //$log.info("vm.selTable:",vm.selTable)
					var newSum = vm.arrCheckSums[i].chkSum;
					if (sum1 == "") {
						sum1 = newSum; //$log.info("sum1:",sum1)
						sumField1 = vm.arrCheckSums[i].sumField; }
					else if (newSum != sum1 && sum2 == "") {
						sum2 = newSum; //$log.info("sum2:",sum2)
						sumField2 = vm.arrCheckSums[i].sumField; }
					else if (newSum != sum1 && newSum != sum2 && sum3 == "") {
						sum3 = newSum; //$log.info("sum3:",sum3)
						sumField3 = vm.arrCheckSums[i].sumField; }
					else if (newSum != sum1 && newSum != sum2 && newSum != sum3) {
						dataService.emailSendCustom('lori@greatspirit.com','lori@greatspirit.com',
							'lori@greatspirit.com','Additional CheckSum field needed',
							'In Stats/statsEntryCtrl validateSums(), a sum4 variable is needed.');
					}
				}
			}	
			if (sum1 != "") { //$log.info("Run CheckSum1")
				for (i=0; i<vm.arrCheckSums.length; i++) {
					if (vm.arrCheckSums[i].chkSum == sum1) {
						//calculate the CheckSum(1):
						for (var j=0; j<vm.arrDataFields.length; j++) {
							if (vm.arrDataFields[j].statItem == vm.arrCheckSums[i].statItem) {
								var sSum1Amt = vm.arrDataFields[j].data;
								var dSum1Amt = formatterService.digitsOnly(sSum1Amt);
								sum1Amt += Number(dSum1Amt); //$log.info("sum1Amt:",sum1Amt);
							} else if (vm.arrDataFields[j].statItem == sumField1) {
								var sSum1sum = vm.arrDataFields[j].data;
								var dSum1sum = formatterService.digitsOnly(sSum1sum);
								sum1sum = Number(dSum1sum); //$log.info("sum1sum=",sum1sum);
							}
						}
					} else if (sum2 != "" && vm.arrCheckSums[i].chkSum == sum2) { //$log.info("Run CheckSum2")
						for (j=0; j<vm.arrDataFields.length; j++) {
							if (vm.arrDataFields[j].statItem == vm.arrCheckSums[i].statItem) {
								var sSum2Amt = vm.arrDataFields[j].data;
								var dSum2Amt = formatterService.digitsOnly(sSum2Amt);
								sum2Amt += Number(dSum2Amt); //$log.info("sum2Amt:",sum2Amt);
							} else if (vm.arrDataFields[j].statItem == sumField2) {
								var sSum2sum = vm.arrDataFields[j].data;
								var dSum2sum = formatterService.digitsOnly(sSum2sum);
								sum2sum = Number(dSum2sum);
							}	
						}
					} else if (sum3 != "" && vm.arrCheckSums[i].chkSum == sum3) {
						for (j=0; j<vm.arrDataFields.length; j++) {
							if (vm.arrDataFields[j].statItem == vm.arrCheckSums[i].statItem) {
								var sSum3Amt = vm.arrDataFields[j].data;
								var dSum3Amt = formatterService.digitsOnly(sSum3Amt);
								sum3Amt += Number(dSum3Amt); //$log.info("sum3Amt:",sum3Amt);
							} else if (vm.arrDataFields[j].statItem == sumField3) {
								var sSum3sum = vm.arrDataFields[j].data;
								var dSum3sum = formatterService.digitsOnly(sSum3sum);
								sum3sum = Number(dSum3sum);
							}	
						}
					}
				}
			}
			vm.bChkSumsOff = false; 	//reset
			vm.sChkSumsErrorTable = "";
			if (sum1 != "") {
				if (sum1Amt != sum1sum) { //$log.info("sum1:",sum1,sum1Amt,"!=",sum1sum)
					for (i=0; i<vm.arrDataFields.length; i++) {
						if (vm.arrDataFields[i].source.substr(0,sum1.length)== sum1) { 
// $log.info("ChkSumsOff:",vm.arrDataFields[i])
							vm.arrDataFields[i].Locked = "ChkSumsOff"; 
						} else if (vm.arrDataFields[i].statItem == sumField1) { 
// $log.info("SumChkSumsOff:",vm.arrDataFields[i])
							vm.arrDataFields[i].Locked = "SumChkSumsOff";
							vm.sChkSumsErrorTable = vm.arrDataFields[i].form;
						}
					}
					vm.bChkSumsOff = true;
				} else {
					for (i=0; i<vm.arrDataFields.length; i++) {
						if (vm.arrDataFields[i].source.substr(0,sum1.length)== sum1) {
							vm.arrDataFields[i].Locked = "Enter"; }
						else if (vm.arrDataFields[i].statItem == sumField1) {
							vm.arrDataFields[i].Locked = "Sum";
						}
					}
				}	
			}
			if (sum2 != "") {
				if (sum2Amt != sum2sum) {
					for (i=0; i<vm.arrDataFields.length; i++) {
						if (vm.arrDataFields[i].source.substr(0,sum2.length)== sum2) {
							vm.arrDataFields[i].Locked = "ChkSumsOff"; }
						else if (vm.arrDataFields[i].statItem == sumField2) {
							vm.arrDataFields[i].Locked = "SumChkSumsOff";
							vm.sChkSumsErrorTable = vm.arrDataFields[i].form;
						}
					}
					vm.bChkSumsOff = true;
				} else {
					for (i=0; i<vm.arrDataFields.length; i++) {
						if (vm.arrDataFields[i].source.substr(0,sum2.length)== sum2) {
							vm.arrDataFields[i].Locked = "Enter"; }
						else if ((sumField2 != sumField1 || vm.bChkSumsOff == false) &&
							vm.arrDataFields[i].statItem == sumField2) {
							vm.arrDataFields[i].Locked = "Sum";
						}
					}
				}	
			}
			if (sum3 != "") {
				if (sum3Amt != sum3sum) {
					for (i=0; i<vm.arrDataFields.length; i++) {
						if (vm.arrDataFields[i].source.substr(0,sum3.length)== sum3) {
							vm.arrDataFields[i].Locked = "ChkSumsOff"; }
						else if (vm.arrDataFields[i].statItem == sumField3) {
							vm.arrDataFields[i].Locked = "SumChkSumsOff";
							vm.sChkSumsErrorTable = vm.arrDataFields[i].form;
						}
					}
					vm.bChkSumsOff = true;
				} else {
					for (i=0; i<vm.arrDataFields.length; i++) {
						if (vm.arrDataFields[i].source.substr(0,sum3.length)== sum3) {
							vm.arrDataFields[i].Locked = "Enter"; }
						else if (((sumField3 != sumField2 && sumField3 != sumField1) ||
							vm.bChkSumsOff==false) && vm.arrDataFields[i].statItem == sumField3) {
							vm.arrDataFields[i].Locked = "Sum";
						}
					}
				}	
			}
// $log.info(vm.sChkSumsErrorTable, 'checkSums are off')
			if (vm.bChkSumsOff) {
				switch (vm.sChkSumsErrorTable) {
					case 'Table 1': checkSumsService.readyToSubmit.Table1 = false; break;
					case 'Table 2 Worksheet': checkSumsService.readyToSubmit.Table2Ws = false; break;
					case 'Table 2': checkSumsService.readyToSubmit.Table2 = false; break;
					case 'Table 3': checkSumsService.readyToSubmit.Table3 = false; break;
					case 'Table 4': checkSumsService.readyToSubmit.Table4 = false; break;
					case 'Table 9': checkSumsService.readyToSubmit.Table9 = false; break;
				}
			} else {
				switch (vm.selTable) {
					case 'Table 1': checkSumsService.readyToSubmit.Table1 = true; break;
					case 'Table 2 Worksheet': checkSumsService.readyToSubmit.Table2Ws = true; break;
					case 'Table 2': checkSumsService.readyToSubmit.Table2 = true; break;
					case 'Table 3': checkSumsService.readyToSubmit.Table3 = true; break;
					case 'Table 4': checkSumsService.readyToSubmit.Table4 = true; break;
					case 'Table 9': checkSumsService.readyToSubmit.Table9 = true; break;
				}
			}		
		}
	}
	
	function saveData() { 	$log.info("saveData():",vm.arrDataFields)
		var sRawDataString = "";
		for (var i=0; i<vm.arrDataFields.length; i++) {
			if (vm.arrDataFields[i].data != "") {
				switch (vm.arrDataFields[i].numDol) {
					case "Number": case "Dollars":
						var str = vm.arrDataFields[i].data;
						vm.arrDataFields[i].data = formatterService.digitsOnly(str);
					break;
					case "Yes|No":
						if (vm.arrDataFields[i].data == "Yes") { vm.arrDataFields[i].data = 1; }
						else if (vm.arrDataFields[i].data == "No") { vm.arrDataFields[i].data = 0; }
						else { vm.arrDataFields[i].data == ""; }
					break;
				}
				sRawDataString += " || " + vm.arrDataFields[i].statItem + "==" + vm.arrDataFields[i].data;
			}
		}
		if (sRawDataString != "") {
			var sSaveString = "WebApps_Stats || v.008 || " + loginService.user.USERID +
				" || U || SaveKey==" + vm.arrData[0].SAVEKEY + " || FormName==" + vm.selTable +
				sRawDataString + " ^^ ";
$log.info('sSaveString:', sSaveString);
			dataService.statSaveStatData(sSaveString)
			.then(function(result) {
				if (result[0].RESULTCODE == 'Success') {
					vm.bReadyToSave = 'false';
					refreshStatus();	//calls setCompleted()
					getStatData();		//calls loadDisplay()
				} else {
					modalService.okAlert("Save Error",
						"An Error occurred while trying to save the Statistical data.<br>" + 
						result[0].RESULTREASON);
				}
			});
		}
	}
	
	//Uses the StatGetFormStatus record to display %complete, or Submitted, or Save buttons:
	function setCompleted() {
		vm.sPercentComplete = statTableService.getStatus(vm.selTable, vm.statRecord); 
		if (vm.sPercentComplete.substr(0,9) == "Submitted") {
			vm.bSubmitted = true; 
		}
	}
	
	function setTableText() {
		switch (vm.selTable) {
			case "Table 1": vm.sTableText = vm.sTable1Text;	break;
			case "Table 2": vm.sTableText = vm.sTable2Text;	break;
			case "Table 2 Worksheet": vm.sTableText = vm.sTable2WsText;	break;
			case "Table 3": vm.sTableText = vm.sTable3Text;	break;
			case "Table 4": vm.sTableText = vm.sTable4Text; break;
			case "Table 9": vm.sTableText = vm.sTable9Text; break;
		}
	}
	
	function submitHandler(saveKey) {
		var sRawDataString = "WebApps_Stats || v.001 || " + loginService.user.USERID + " || ";
		if (saveKey > 0) {
			sRawDataString += "U || SaveKey==" + saveKey;
		} else { sRawDataString += "I"; }
		sRawDataString += " || EntityID==" + vm.iChurchID + " || FormYear==" + vm.statRecord.FORMYEAR + 
			" || FormName==" + vm.selTable + " || CompletedOn==" + datesService.nowAsDbDatePlusTime() + 
			" || CompletedBy==" + loginService.user.USERID + " ^^ ";
				
		dataService.statSaveCompleted(sRawDataString)
		.then(function(submit) {
			if (submit[0].RESULTCODE == 'Success') {
				refreshStatus();	//includes setCompleted()
				getStatData();		//includes loadDisplay()
			} else {
				modalService.okAlert("Save Error",
						"An Error occurred while trying to submit the Statistics table.<br>" + 
						submit[0].RESULTREASON);
			}
		});
	}
	
	function validateSums(sStat) { //$log.info("StatSum:",sStat)
		if (vm.arrSums.length > 0) {
			var sumItem1 = "";
			var sumItem2 = "";
			var sumItem3 = "";
			var sumAmt1 = 0;
			var sumAmt2 = 0;
			var sumAmt3 = 0;
			var sumOfSum1 = "";
			var sumOfSum2 = "";
			var totSum1 = 0;
			var totSum2 = 0;
 
			//Find all the sums this statItem feeds into:
			for (var i=0; i<vm.arrSums.length; i++) {
				if (vm.arrSums[i].statItem == sStat) {
					if (sumItem1 == "") {
						sumItem1 = vm.arrSums[i].sumField; 
					} else if (sumItem2 == "") {
						sumItem2 = vm.arrSums[i].sumField;
					} else if (sumItem3 == "") {
						sumItem3 = vm.arrSums[i].sumField;
					} else {
						dataService.emailSendCustom('lori@greatspirit.com','lori@greatspirit.com',
							'lori@greatspirit.com','Additional Sum field needed',
							'In Stats/statsEntryCtrl validateSums(), a sumItem4 variable is needed. Table: ' +
							vm.selTable);
					}
				}
			}
			
			//Find if any of the sumItems ALSO feed into another sumItem:
			for (i=0; i<vm.arrSums.length; i++) {
				if (sumItem1 != "" && vm.arrSums[i].statItem == sumItem1) {
					if (sumOfSum1 == "") {
						sumOfSum1 = vm.arrSums[i].sumField;
					} else if (sumOfSum2 == "") {
						sumOfSum2 = vm.arrSums[i].sumField;
					} else {
						dataService.emailSendCustom('lori@greatspirit.com','lori@greatspirit.com',
							'lori@greatspirit.com','Additional Sum field needed',
							'In Stats/statsEntryCtrl validateSums(), a sumOfSum3 variable is needed. Table: ' +
							vm.selTable);
					}
				} else if (sumItem2 != "" && vm.arrSums[i].statItem == sumItem2) {
					if (sumOfSum1 == "") {
						sumOfSum1 = vm.arrSums[i].sumField;
					} else if (sumOfSum2 == "") {
						sumOfSum2 = vm.arrSums[i].sumField;
					} else {
						dataService.emailSendCustom('lori@greatspirit.com','lori@greatspirit.com',
							'lori@greatspirit.com','Additional Sum field needed',
							'In Stats/statsEntryCtrl validateSums(), a sumOfSum3 variable is needed. Table: ' +
							vm.selTable);
					}
				} else if (sumItem3 != "" && vm.arrSums[i].statItem == sumItem3) {
					if (sumOfSum1 == "") {
						sumOfSum1 = vm.arrSums[i].sumField;
					} else if (sumOfSum2 == "") {
						sumOfSum2 = vm.arrSums[i].sumField;
					} else {
						dataService.emailSendCustom('lori@greatspirit.com','lori@greatspirit.com',
							'lori@greatspirit.com','Additional Sum field needed',
							'In Stats/statsEntryCtrl validateSums(), a sumOfSum3 variable is needed. Table: ' +
							vm.selTable);
					}
				}
			}

			//Calculate the Sum from current data:
			for (i=0; i<vm.arrSums.length; i++) {
				switch (vm.arrSums[i].sumField) {
					case sumItem1:
						for (var j=0; j<vm.arrDataFields.length; j++) { 
							if (vm.arrDataFields[j].statItem == vm.arrSums[i].statItem) {
								var pattern = /\D/g;
								var str = vm.arrDataFields[j].data;
								vm.arrDataFields[j].data = str.replace(pattern,'');	
								if (vm.arrSums[i].math == "+") {
									sumAmt1 += Number(vm.arrDataFields[j].data); }
								else { sumAmt1 -= Number(vm.arrDataFields[j].data); }
							break; }
						}
					break;
					case sumItem2:
						for (j=0; j<vm.arrDataFields.length; j++) { 
							if (vm.arrDataFields[j].statItem == vm.arrSums[i].statItem) {
								str = vm.arrDataFields[j].data;
								vm.arrDataFields[j].data = str.replace(pattern,'');	
								if (vm.arrSums[i].math == "+") {
									sumAmt2 += Number(vm.arrDataFields[j].data); }
								else { sumAmt2 -= Number(vm.arrDataFields[j].data); }
							break; }
						}
					break;
					case sumItem3:
						for (j=0; j<vm.arrDataFields.length; j++) { 
							if (vm.arrDataFields[j].statItem == vm.arrSums[i].statItem) {
								str = vm.arrDataFields[j].data;
								vm.arrDataFields[j].data = str.replace(pattern,'');	
								if (vm.arrSums[i].math == "+") {
									sumAmt3 += Number(vm.arrDataFields[j].data); }
								else { sumAmt3 -= Number(vm.arrDataFields[j].data); }
							break; }
						}
					break;
				}
			}
			
			//Put the Sums into the display SumField:
			for (j=0; j<vm.arrDataFields.length; j++) { 
				switch (vm.arrDataFields[j].statItem) {
					case sumItem1:
						if (sumAmt1 == 0) {
							vm.arrDataFields[j].data = "0";
						} else { vm.arrDataFields[j].data = formatterService.addThousandsCommas(sumAmt1); }
					break;
					case sumItem2:
						if (sumAmt2 == 0) {
							vm.arrDataFields[j].data = "0";
						} else { vm.arrDataFields[j].data = formatterService.addThousandsCommas(sumAmt2); }
					break;
					case sumItem3:
						if (sumAmt3 == 0) {
							vm.arrDataFields[j].data = "0";
						} else { vm.arrDataFields[j].data = formatterService.addThousandsCommas(sumAmt3); }
					break;
				}
			}	
			
			//Calculate the Sums of Sums:
			for (i=0; i<vm.arrSums.length; i++) {
				switch (vm.arrSums[i].sumField) {
					case sumOfSum1:
						for (j=0; j<vm.arrDataFields.length; j++) { 
							if (vm.arrDataFields[j].statItem == vm.arrSums[i].statItem) {
								str = vm.arrDataFields[j].data;
								vm.arrDataFields[j].data = str.replace(pattern,'');	
								if (vm.arrSums[i].math == "+") {
									totSum1 += Number(vm.arrDataFields[j].data); }
								else { totSum1 -= Number(vm.arrDataFields[j].data); }
							break; }
						}
					break;
					case sumOfSum2:
						for (j=0; j<vm.arrDataFields.length; j++) { 
							if (vm.arrDataFields[j].statItem == vm.arrSums[i].statItem) {
								str = vm.arrDataFields[j].data;
								vm.arrDataFields[j].data = str.replace(pattern,'');	
								if (vm.arrSums[i].math == "+") {
									totSum2 += Number(vm.arrDataFields[j].data); }
								else { totSum2 -= Number(vm.arrDataFields[j].data); }
							break; }
						}
					break;
				}
			}
			
			//Put the Sums into the display SumField:
			for (j=0; j<vm.arrDataFields.length; j++) { 
				switch (vm.arrDataFields[j].statItem) {
					case sumOfSum1:
						if (totSum1 == 0) {
							vm.arrDataFields[j].data = "0";
						} else { vm.arrDataFields[j].data = formatterService.addThousandsCommas(totSum1); }
					break;
					case sumOfSum2:
						if (totSum2 == 0) {
							vm.arrDataFields[j].data = "0";
						} else { vm.arrDataFields[j].data = formatterService.addThousandsCommas(totSum2); }
					break;	
				}
			}
		}
	}
	
	
/* Broadcasts: */

// HANDLERS:
	vm.cancelHandler = function() { //$log.info("cancel") -- watch for timing issue. Use $rootScope.curTable
		timeOutService.resetTimer(30);
		
		if (vm.bReadyToSave == 'true' || vm.bReadyToSave == 'warn') {		
			vm.bReadyToSave = 'false';
			vm.bChkSumsOff = 'false';
			getStatData();	
		} 	
	};
	
	vm.changeDataHandler = function(item) { $log.info("changeItem:",item)
		timeOutService.resetTimer(30);
		
/** Removed Custom code for MO:		
// 		var bAllowChanges = true;
		//Special Handling of custom statItems:
/*
		switch (item.statItem) {
			case "T4_I1a_WorAttn1": case "T4_I1b_WorAttn2":
			case "T4_I1c_WorAttn3": case "T4_I1d_WorAttn4":
				//Custom: MO Table 4
				for (var i=0; i<vm.arrDataFields.length; i++) {
					if (vm.arrDataFields[i].statItem == "T4_I1_TotWorAttn") {
						if (vm.arrDataFields[i].data == "") {
							bAllowChanges = false;
							item.data = "";
							modalService.okAlert("Missing Entry", 
								"You must Complete and Save the \"Average Attendance at all weekly " +
								"worship services\" on Table 1 before you can enter data on this item.");			
						}
					break; }
				}
			break;
		}
**/
		if (item.numDol == "Text") {
			if (item.data.length > 100) {
				item.data = item.data.substr(0,100);
				modalService.okAlert("Character Limit",
					"You've reached the maximum number of characters allowed in this field.");
			}
		}
		
// 		if (bAllowChanges) {
			vm.bReadyToSave = 'true';
			//Special Handling prior to Summing:
			switch (item.numDol) {
				case "Number": case "Dollars":
					var pattern = /\D/g;
					var str = item.data;
					item.data = str.replace(pattern,''); $log.info(item.data);
					
					/** Validate if '', that if previously NOT blank, fill with 0. 
					*	Do not want to do this if no previous value, as blank shows user they
					*	had not completed yet... but if removing, then replace with 0.
					*/
// 					if (item.data == '') {
						/** Not sure if should implement this... */
// 					}
				break;	
			}
			validateSums(item.statItem);
			if (vm.bChkSumsOff == true) {
				runTheCheckSums();
			}
// 		}	
	};
	
	vm.changeTableHandler = function() {
		timeOutService.resetTimer(30);
		
		if (vm.bReadyToSave == 'false') {
			vm.bSubmitted = false;	//reset
			vm.arrChecksums = [];	//reset
			vm.arrSums = [];		//reset
	
			//Custom LA:
			if ((vm.sDatabaseID=='LA'||vm.sDatabaseID=='LA-DEV') &&
				vm.selTable == 'Table 2' &&
				statTableService.getStatus('Table 2 Worksheet', vm.statRecord).substr(0,9)!='Submitted') {
				vm.selTable = 'Table 2 Worksheet';
				modalService.okAlert("Missing Worksheet Data", 
					"You must Complete and Submit the Table 2 Worksheet before you are " +
					"able to complete Table 2.");
			}
			setCompleted();		//run first to set vm.bSubmitted, so fields in display are disabled
			loadDisplay();		//creates sum & checkSum arrays
			setTableText();
		} else { 
			modalService.okAlert("Unsaved Changes",
				"Please Save or Cancel your data changes before changing tables.");
		}
	};
	
	vm.enterAsTab = function(event,id) {
		if (event.which === 13) {
			event.preventDefault();
			for (var i=0; i<vm.arrDataFields.length; i++) {
				if (vm.arrDataFields[i].seq == id) { //$log.info("defs:",vm.arrDataFields[i])
					for (var j=(i+1); j<vm.arrDataFields.length; j++) {
						if (vm.arrDataFields[j].ds == 'Enter') {
							var itemID = vm.arrDataFields[j].seq;
						break; }
					}
				break; }
			}
			var elementToFocus = $window.document.getElementById(itemID);
			if (elementToFocus) {
				elementToFocus.focus();
			}
		}
	};
	
	vm.print = function() {
		timeOutService.resetTimer(30);
		
		// AutoSave any unsaved changes:
		if (vm.bReadyToSave != 'false') {
			saveData();	
		}
		$state.go('print', {
			arrTables: vm.arrTables,
			sChurchName: vm.sChurchName,
			statRecord: vm.statRecord
		});
	};
	
	vm.returnToStatsHist = function() {
		timeOutService.resetTimer(30);
		
		$state.go('statHist', {
			iChurchID: vm.iChurchID,
			sChurchName: vm.sChurchName
		});
	};	
	
	vm.saveHandler = function() {
		timeOutService.resetTimer(30);
		
		if (vm.bReadyToSave == 'true') {
			runTheCheckSums();
			if (vm.bChkSumsOff == true) {
				if (vm.selTable == vm.sChkSumsErrorTable) {
					vm.bReadyToSave = 'warn';
					modalService.okAlert("Warning!",
						"There are CheckSums that are not equal.<br><br>" +
						"Please correct the highlighted fields to balance with the " +
						"highlighted sum. Or you may click the Save button again to " +
						"continue to save.<br><br>" +
						"You will be unable to Submit this table until all CheckSums are equal.");
				} else {
					modalService.okAlert("Warning!",
						"There are CheckSums that are not equal.<br>" +
						"After the Save completes, please return to " + vm.sChkSumsErrorTable + 
						" to correct the highlighted fields to balance with the highlighted sum.");
					saveData();
				}
			} else {
				saveData(); 
			}
		} else if (vm.bReadyToSave == 'warn') {
			runTheCheckSums();
			saveData();
		} else {
			modalService.okAlert("Oops!",
				"We did not find any data changes to Save.");
		}
	};
	
	vm.submitTable = function() {
		timeOutService.resetTimer(30);
/*
		if (vm.bChkSumsOff == true) {
			modalService.okAlert("Warning!",
				"There are CheckSums that are not equal.<br><br>" +
				"You will not be able to submit this form until the highlighted fields " +
				"balance with the highlighted sum.")
		} else {
*/
			dataService.statGetCompleted(vm.iChurchID, vm.statRecord.FORMYEAR, vm.selTable)
			.then(function(result) {
// $log.info('statGetCompleted:', result);
				if (result.length > 0) {
					submitHandler(result[0].SAVEKEY);
				} else {
					submitHandler(0); 
				}
			});		
// 		}
	};
	
}
angular
    .module('stats')
    .controller('StaffController', StaffController);

StaffController.$inject = ['dataService'];

function StaffController(dataService) { 

    var vm = this;
    
    vm.arrContacts = [];
    
    dataService.libLoadList()
    .then(function(list) {
		if (list.length > 0) {
			vm.arrContacts = list;
		}
    });

}

angular
    .module('stats')
    .controller('PrintController', PrintController);

PrintController.$inject = ['$rootScope','$stateParams','$state','$window','dataService','$uibModal',
	'modalService', 'timeOutService', '$log'];

function PrintController($rootScope, $stateParams, $state, $window, dataService, $uibModal, 
	modalService, timeOutService, $log) {
    var vm = this;
    
    vm.back = { image: "assets/images/left_32.png" };
    vm.bAllTables = true;
    vm.optPrint = "1";
    vm.arrTables = $stateParams.arrTables;
    vm.rptUrl = "";

    
//INITIALIZE:
	$rootScope.sCurForm = "Print";
$log.info($rootScope.sCurForm)
    
    for (var i=0; i<vm.arrTables.length; i++) {
		vm.arrTables[i].selected = false;
    }
    


// HANDLERS:

	vm.goBack = function() {
		timeOutService.resetTimer(30);
		
		$state.go('statEntry', {
			sChurchName: $stateParams.sChurchName,
			statRecord: $stateParams.statRecord
		}, {reload:true});
	};
	
	vm.printStatistics = function() {
		timeOutService.resetTimer(30);
		
		if (vm.bAllTables == true) {
			var tbl = 'all';
		} else {
			tbl = "*";
			for (var i=0; i<vm.arrTables.length; i++) {
				if (vm.arrTables[i].selected == true) {
					tbl += vm.arrTables[i].FORM + "*";
				}
			}
		}
		
		dataService.rptStatChurch(tbl, $stateParams.statRecord.FORMYEAR, 
			$stateParams.statRecord.ENTITYID, vm.optPrint)
		.then(function(rpt) {
			if (rpt.length > 0) {
				vm.rptUrl = "https://umcdata.net" + rpt[0].REPORTURL;
				modalService.okPrintAlert("Print Statistics","Your report is ready to Print!",
					vm.rptUrl);
				
			}
		});
	};

}

angular		
	.module('stats')
	.controller('NavBarController', NavBarController);

NavBarController.$inject = ['$state','webSessionStorage','headerService','$scope','modalService',
	'$rootScope', 'loginService','version','chrgApptsURL','mcWebAppsURL','minFinURL','protectURL','lclURL',
	'$window','custData','custDataDev','dataService','$log'];
	
function NavBarController($state, webSessionStorage, headerService, $scope, modalService,
	$rootScope, loginService, version, chrgApptsURL, mcWebAppsURL, minFinURL, protectURL, lclURL,  
	$window, custData, custDataDev, dataService, $log) {
	var vm = this;

	vm.loggedIn = false;
	vm.headerIcon = headerService.getHeaderIcon();
	vm.isCollapsed = true;
	vm.myApps = [];
	vm.sCustomerName = headerService.customer.name;
	vm.version = version;

	function getAppsForMenu() {
		vm.myApps = [];
		dataService.userGetChurchFunctions()
		.then(function(apps) { //$log.info("getApps:",apps, vm.myApps)
			if (apps.length > 0) {
				for (var i=0; i<apps.length; i++) {
					switch (apps[i].FN) {
						case "ChLeaders":
							vm.myApps.push("Local Church Leaders");
						break;
						case "Center":
							vm.myApps.push("Center");
							break;
						case "ContactInfo":
							vm.myApps.push("Contact Information");
						break;
						case "MinFin":
							vm.myApps.push("Ministry Financials");
						break;
						case "ProRef":
							var dataSource = webSessionStorage.getStoredData('sDataSource');
							if (dataSource.slice(-3) == "Dev" || dataSource == "FalconVideos") {
								for (var j=0; j<custDataDev.length; j++) {
									custData.push(custDataDev[j]);
								}
							}
							for (j=0; j<custData.length; j++) {
								if (custData[j].DataSource == dataSource) {
									var ProRefApp = custData[j].ProRef;
								break; }
							}
							vm.myApps.push(ProRefApp);
						break;
						case "Statistics":
// 							vm.myApps.push("Statistics"); ==> Don't need to list SELF!
						break;	
					}
				}
			}
		});
	}

/* Broadcasts: */	 
	$scope.$on('closeMenu', function() {
		vm.isCollapsed = true;
	});
	
	$scope.$on('updateCustomer', function() {
		vm.headerIcon = headerService.getHeaderIcon();
		vm.sCustomerName = headerService.customer.name;
	});
	
	$scope.$on('updateNav', function() {
		vm.myApps = $rootScope.myApps;
		vm.loggedIn = loginService.user.loggedIn;
		getAppsForMenu();
	});

	
/* Calls from View: */

	vm.goHome = function() {
		$state.go('login', {reload:true});
	};
	
	vm.goToAbout = function() {
		$rootScope.sCurForm = "about";
		$state.go('about');
	}
	
	vm.goToApp = function(app) {
		if ($rootScope.bPasswordExpired == true) {
			modalService.okAlert("Password Expired",
				"Your current password has expired.");
			$state.go('chgPW');	
		} else {
			var sFn = "";
			var sPath = "";
			switch (app) {
				case "Center":
					sFn = "Center";
					sPath = chrgApptsURL;
				break;
				case "Contact Information":
					sFn = "ContactInfo";
					sPath = mcWebAppsURL;
				break;
				case "Local Church Leaders":
					sFn = "ChLeaders";
					sPath = lclURL;
				break;
				case "Ministry Financials":
					sFn = "MinFin";
					sPath = minFinURL;
				break;
				case "Safe Sanctuary References": 	//MO
				case "Volunteer References":		//NWTX
				case "Protect References":			//DEFAULT
					sFn = "ProRef";
					sPath = protectURL;
				break;
				case "SignUp":
					//coming...
				break;
				case "Statistics":
					sFn = "Statistics";
					$rootScope.sCurForm = "Statistics Records";
				break;
			}
	
		/** Call for NEW ReturnCode set to expire in 1 minute...
		  *	 And go to new app (sFn), which will login to new app.
		  **/
			switch (sFn) {
				case "Statistics": //local path
					$state.go('statHist');
				break;
				default: // External Apps:
					loginService.secGetReturnCode(1, sFn)
					.then(function(result) {
						$window.location.replace(sPath + "?ReturnCode=" + 
							result[0].RETURNCODE);
					});
				break;
			}
		}	
	}; //goToApp()
	
	vm.goToChgPW = function() {
		$rootScope.sCurForm = "chgPW";
		$state.go('chgPW');
	};
	
	vm.goToHelpDesk = function() {
		$state.go('helpDesk', {reload:true});
	};
	
	/** Removes all secure app permission, sending user back to
	  *	 login screen and retaining selected Customer: 
	  **/	
	vm.logOff = function() {
		vm.loggedIn = false;
		loginService.logout();
		vm.myApps = [];
		$state.go('login', {reload: true});
	};
	
}	 

angular
    .module('stats')
    .controller('ModalController', ModalController);

ModalController.$inject = ['$uibModalInstance','modType','title','alertMsg','$sce'];

function ModalController($uibModalInstance, modType, title, alertMsg, $sce) {
    var vm = this;
    
    vm.modType = modType;	//OK, printOpts, ...
    vm.sTitle = title;
    vm.sAlertMsg = $sce.trustAsHtml(alertMsg);
    
	vm.ok = function() {
		$uibModalInstance.close();
	}
	
	vm.cancel = function() {
		$uibModalInstance.dismiss();
	};
	
	vm.open = function() {
		$uibModalInstance.close({open: true});
	};
	
}

angular
    .module('stats')
    .controller('ModalTimeoutController', ModalTimeoutController);

ModalTimeoutController.$inject = ['$uibModalInstance','$timeout'];

function ModalTimeoutController($uibModalInstance, $timeout) {
    var vm = this;
    vm.secTimer = 60;
    
    runTimer();
    
	function runTimer() {
		$timeout(function () {
			vm.secTimer--;
			if (vm.secTimer > 0) {
				runTimer();	
			} else {
				$uibModalInstance.close({continue: false});
			}
		}, 1000);		
	}
	
	vm.continue = function() {
		$uibModalInstance.close({continue: true});	
	};
}
angular
    .module('stats')
    .controller('ModalConfSelectController', ModalConfSelectController);

ModalConfSelectController.$inject = ['$uibModalInstance','confs','$log'];

function ModalConfSelectController($uibModalInstance, confs, $log) {
$log.info("ModalConfSelectController");	

	var vm = this;
	vm.confs = confs;
	vm.options = {};
	
	vm.ok = function (sConfSel) {
		$uibModalInstance.close(sConfSel);
    };

	vm.cancel = function () {
		$uibModalInstance.dismiss('cancel');
	};

}
/** UPDATES:
  * 	* 01/15/19 lds - Added timeOutService, and resetting of Customer on form reload.
  **/

angular
	.module('stats')
	.controller('LoginController', LoginController);

LoginController.$inject = ['webSessionStorage','$rootScope','dataService','$state',
	'loginService','$uibModal','modalService','custData','headerService','appValidationService',
	'setCustService','timeOutService'];

function LoginController(webSessionStorage, $rootScope, dataService, $state, 
	loginService, $uibModal, modalService, custData, headerService, appValidationService,
	setCustService, timeOutService) {
	var vm = this; //as vmLI
	
	vm.bShowConferences = false;
	vm.custDB = custData;
	vm.selConf = custData[0];
	vm.sDatabaseID = webSessionStorage.getStoredData('sDatabaseID');
	vm.sUsername = "";
	vm.sPassword = "";
	vm.sWelcomeHdr = "";
	
	
//INITIALIZE:	
	$rootScope.sCurForm = 'Login';


	/** When returning here, with {reload: true}, ensure
	  *  that Customer is still 'set' in NavBar by calling
	  *  setCustService if sDatabaseID still in Session storage:
	  **/
	if (vm.sDatabaseID !== null &&
		angular.isDefined(vm.sDatabaseID) == true) {
		setCustService.fromDatabaseID(vm.sDatabaseID);	
	} else { vm.bShowConferences = true; }

	
	function logInUser() {
		loginService.login(vm.sUsername, vm.sPassword)
		.then(function(data) {
			if (data[0].SECUSERLOGIN[0].RESULT == "Success") {
				var sExp = data[0].SECUSERLOGIN[0].PASSWORDEXPIRES;
				var dPasswordExpires = new Date(sExp.substr(0,4),
					Number(sExp.substr(5,2))-1, sExp.substr(8,2));
				var dToday = new Date();
				if (dPasswordExpires > dToday) {
					/* Start Session Timer: */
					timeOutService.setTimer(30);

				/* Determine landing page... */
					if (appValidationService.validateAccess() == "Valid") {
						$rootScope.sCurForm = 'Statistics Records';
						$state.go('statHist');
					} else { 
						$rootScope.sCurForm = 'Login';
						$state.go('login'); 
					}
				} else {
					$rootScope.bPasswordExpired = true;
					modalService.okAlert("Expired Password",
						"Your current password has expired.\n" +
						"You must create a new password to continue.");
					$state.go('chgPW');
				}	
			} else if (data[0].SECUSERLOGIN[0].RESULT == "Fail"){
				modalService.okAlert('Login Failed',
					'We were unable to log you in with the Username and Password provided.<br><br>' +
					'Please try again, or have a password reset link sent to the email address ' +
					'associated with this account by clicking the \"Forgot Password\" button.');
			} else if (data[0].SECUSERLOGIN[0].RESULT == "Multiple") {
				openConfSelectModal(data[0].SECUSERLOGIN[0].HELPGETDBBYUSER, false);
			} else {
				modalService.okAlert('Login Failed',
					'We were unable to log you in with the Username and Password provided.<br><br>' +
					'Please try again, or have a password reset link sent to the email address ' +
					'associated with this account by clicking the \"Forgot Password\" button.');
			}
		});
	}
	
	
//Modals:
	function openConfSelectModal(arrConfs, bPwReset) {
		var modalInstance = $uibModal.open({
			animation: true,
			size: 'lg',
			templateUrl: 'app/modals/modConfSelectModal.html',
			controller: 'ModalConfSelectController',
			bindToController: true,
			controllerAs: 'vmSel',
			keyboard: true,
			backdrop: 'static',
			backdropClass: 'bottom:0;height:100%;margin:0;padding-bottom:0',
			resolve: {
				confs: function() {
					return arrConfs;
				}
			}
		});
		modalInstance.result
		.then(function(modResult) {
			setCustService.fromDataSource(modResult.DATASOURCE);
			if (bPwReset) {
				vm.forgotPassword_clickHandler();
			} else {
				vm.validateUserLogin();					
			}
		});
	}

	
/* Calls from View: */
  
	vm.enterKeyHandler = function($event) {
		if ($event.keyCode === 13) {
			if (vm.sUsername.trim() != "" && vm.sPassword.trim() != "") {
				logInUser();
			} else {
				modalService.okAlert("Missing Entry", 
					"Please enter your Username and Password to Log " +
					"In to your account.");
			}	
		}  
	};
	
	vm.forgotPassword_clickHandler = function() {
		if (vm.sUsername == "") {
			modalService.okAlert('Missing Entry', 
				'Please enter your Username, then click the \"Forgot Password\" ' +
				'button again. A password reset link will be sent to the Email address ' +
				'associated with this account.<br><br>' +
				'If you do not receive your password within 10-15 minutes, please contact your ' +
				'MissionConnect Administrator to verify that your account email address is correct.');
		} else {		
			loginService.secPasswordReset(vm.sUsername)
			.then(function(data) {
				switch (data[0].RESULT) {
					case 'No User Account':
						modalService.okAlert("Account Not Found", 
							"There is no user account with that Username.<br><br>" +
							"Please be sure you entered it correctly. The Username is " +
							"Case-Sensitive. Otherwise, contact your MissionConnect " +
							"Administrator to verify the Username you are using is correct.");
						break;
					case 'Multiple':
						openConfSelectModal(data[0].SECUSERLOGIN, true);
						break;
					case 'Completed':
						modalService.okAlert('Password Reset Email Sent', 
							'A password reset link has been sent to ' + data[0].RESULTREASON +
							' from mchelp@greatspirit.com.<br><br>' +
							'Check your Email Inbox for the email with Subject:<br>' +
							'"Your MissionConnect Login Information".<br><br>' +
							'If the email does not arrive within 10-15 minutes, be sure ' +
							'to also check your spam and junk folders.');
						break;
				}
			});
		}
    };
	
//Close MENU:	
	vm.onFocus = function() {
		$rootScope.$broadcast('closeMenu');
	};

/* When selected Customer changes, headerService is called to "set"
	new Customer icon & name, which in turn calls to update the 
	NavBarCtrl to reflect the change. */	
	vm.selectConference = function() {
		if (vm.selConf.DataSource != "") {
			setCustService.fromDataSource(vm.selConf.DataSource);
			dataService.setDataSource();
		} else {
			headerService.setCustomer("MissionConnect");
		}
	};
	
    vm.validateUserLogin = function() {
		if (vm.sUsername.trim() != "" && vm.sPassword.trim() != "") {
			logInUser();
		} else {
			modalService.okAlert("Missing Entry", 
				"Please enter your Username and Password to Log " +
				"In to your account.");
		}
	};
		
}
angular
    .module('stats')
    .controller('HelpDeskController', HelpDeskController);

HelpDeskController.$inject = ['helpDeskService','$state','loginService','dataService',
	'validatorService','modalService'];	

function HelpDeskController(helpDeskService, $state, loginService, dataService,
	validatorService, modalService) {
	var vm = this;	//vmHD
	
	vm.bReadyToSubmit;
	vm.iIssueID = 0;
	vm.sUserEmail = "";
	vm.sProblem = "";
	vm.sUserFullName = "";
	
	if (loginService.user.USERID > 0) {
		vm.sUserEmail = loginService.user.USEREMAIL;
		vm.sUserFullName = loginService.user.USERFULLNAME;
	}
	
	helpDeskService.helpHdInitiateIssue()
	.then(function(data) {
		if (data[0].ISSUEID > 0) {
			vm.iIssueID = data[0].ISSUEID;
		} else {
			var sError = "There was an Error retrieving the Help Desk " +
				"IssueID for UserID: " + loginService.user.USERID + ", " +
				loginService.user.USERFULLNAME + "<br><br>Reporting issue: " +
				vm.sProblem;
			dataService.emailSendError(sError);
		}		
	});
		
		
/* Externally Called Functions: */

	vm.confirmReadyToSubmit = function() {
		if (vm.sUserFullName != "" && vm.sUserEmail != "" &&
			vm.sProblem != "") {
			if (validatorService.emailIsValid(vm.sUserEmail) == true) {
				vm.bReadyToSubmit = "true"; }
			else {
				vm.bReadyToSubmit = "false";
				modalService.okAlert("Invalid Entry", 
					"The email entered is not a valid email address.<br><br>" +
					"Please enter a valid email address, then click Submit.");		
			}	
		} else { vm.bReadyToSubmit = "false"; }
	};
	
	vm.submitHD = function() {
		if (vm.bReadyToSubmit == "true") {
			if (vm.iIssueID > 0) {
				helpDeskService.helpHdSaveIssue(vm.iIssueID, vm.sUserFullName,
					vm.sUserEmail, vm.sProblem);
			}
		} else if (vm.sUserFullName == "") {
			modalService.okAlert("Missing Data", 
				"Please enter your Name before Submitting " +
				"the Help Desk issue.");
		} else if (vm.sUserEmail == "") {
			modalService.okAlert("Missing Data", 
				"Please enter your Email Address before " +
				"Submitting the Help Desk issue.");
		} else if (vm.sProblem == "") {
			modalService.okAlert("Missing Data", 
				"Please describe the issue you are experiencing " +
				"before Submitting the Help Desk issue.");
		}
	};	
	
}	

angular
    .module('stats')
    .controller('ChgPasswordController', ChgPasswordController);

ChgPasswordController.$inject = ['$rootScope','$state', 'passwordStrength','validatorService',
	'confirmPWChg','dataService','loginService','modalService','appValidationService','$stateParams'];	

function ChgPasswordController($rootScope, $state, passwordStrength, validatorService,
	confirmPWChg, dataService, loginService, modalService, appValidationService, $stateParams) {
	var vm = this;	//vmCP
    
    vm.bHideOldPw = $stateParams.bHideOldPw;
	vm.bPasswordExpired = $rootScope.bPasswordExpired;
    vm.bReadyToSave = "false";
    vm.bReadyToSavePW = false;
    vm.bReadyToSaveEmail = false;
    vm.sPasswordStrength = "Too Short";
    vm.sPWClass = "tooShort";
    vm.sUserEmail = loginService.user.USEREMAIL;
    
    vm.data = { oldPW:"",
		newPW:"", confirmPW:"",
		email:"", confirmEmail:""	
	};
	
//INITIALIZE:	
	$rootScope.sCurForm = "Change Password/Email";
	
	function validateEmail() {
		var emValidate = confirmPWChg.confirmEmail(vm.data.email, vm.data.confirmEmail);
		switch (emValidate) {
			case "true": 
				if (validatorService.emailIsValid(vm.data.email) == true) {
					vm.bReadyToSaveEmail = true; 
					if (vm.data.newPW == "" && vm.data.confirmPW == "") {
						vm.bReadyToSave = 'true';
					}
				} else {
					vm.bReadyToSaveEmail = false;
					vm.data.confirmEmail = "";
					modalService.okAlert("Invalid Email Address", 
						"The email entered is not a valid email address.<br><br>" +
						"Please enter a valid email address.");
				}
			break;
			case "false": 
				//returned when email or confirmEmail is ""
				vm.bReadyToSaveEmail = false;
			break;
			default:
				modalService.okAlert("", emValidate);
			break;
		}
	}
	
	function validatePW() {
		if (vm.data.oldPW != "" || vm.bHideOldPw) {
			var validatePassword = confirmPWChg.confirmPassword(vm.data.newPW, vm.data.confirmPW);
			switch (validatePassword) {
				case "true": 
					if (vm.sPasswordStrength == "Strong" ||
						vm.sPasswordStrength == "Very Strong") {
						vm.bReadyToSavePW = true;
						if ((vm.data.email=="" && vm.data.confirmEmail=="") ||
							vm.bReadyToSaveEmail == true) {
							vm.bReadyToSave = 'true';
						}
					} else {
						vm.bReadyToSavePW = false;
						vm.data.confirmPW = "";
						modalService.okAlert("Password Strength", 
							"The password needs to meet the \"Strong\" " +
							"or \"Very Strong\" validation before it can be saved.");
					}
				break;		
				case "false":
					vm.bReadyToSavePW = false;
					vm.data.confirmPW = "";
				break;
				default:
					vm.bReadyToSavePW = false;
					vm.data.confirmPW = "";
					modalService.okAlert("Password Validation", validatePassword);
				break;
			}		
		}
	}
    
    function saveNewEmail() {
		var sSaveString = "WebStats || chgPW || " + loginService.user.USERID + 
			" || U || UserID==" + loginService.user.USERID + 
			" || UserEmail==" + vm.data.email + " ^^ ";
		
		loginService.usersSave(sSaveString)
		.then(function(data) { 
            if (data[0].RESULTCODE == "Success") {
				var sSaveSuccessMsg = "Your email has been updated successfully!<br>";
				loginService.user.USEREMAIL = vm.data.email;
				if (vm.bReadyToSavePW != true) {
					modalService.okAlert("Save Successful", sSaveSuccessMsg);

					if (!$rootScope.bPasswordExpired) {
						if (appValidationService.validateAccess() == "Valid") {
							$rootScope.sCurForm = 'Statistics Records';
							$state.go('statHist');
						} else { 
							$rootScope.sCurForm = 'Login';
							$state.go('login'); 
						}
					} else { 
						$state.reload();
					}
				} else {
					//also saving new Password:
					saveNewPassword(sSaveSuccessMsg);	
				}
			} else {
				modalService.okAlert("Save Failed", data[0].RESULTCODE);
			}
		});
    }
    
	function saveNewPassword(msg) {
		if (vm.bHideOldPw) {
			var sSaveString = "WebStats || chgPW || " + loginService.user.USERID + 
			" || U || UserID==" + loginService.user.USERID + " || UserName==" +
			loginService.user.USERNAME + " || Password==" + vm.data.newPW + " ^^ ";
			
			loginService.usersSave(sSaveString)
			.then(function(data) {
				if (data[0].RESULTCODE == 'Success') {
					$rootScope.bPasswordExpired = false;
					modalService.okAlert("Save Successful", 
						msg + "Your password has been updated successfully!");
					loginService.login(loginService.user.USERNAME, vm.data.newPW)
					.then(function(loginReturn) {
						if (loginReturn[0].SECUSERLOGIN[0].RESULT == "Success") {
							$rootScope.sCurForm = 'Statistics Records';
							$state.go('statHist');
						}
					});
				} else {
					$state.reload();
					modalService.okAlert("Save Failed", msg + data[0].RESULTREASON);
				}
	 		})
		} else {
			var sSaveString = "WebStats || chgPW || " + loginService.user.USERID +
				" || U || UserID==" + loginService.user.USERID + " || UserName==" +
				loginService.user.USERNAME + " || OldPassword==" + vm.data.oldPW +
				" || NewPassword==" + vm.data.newPW + " || PWStrength==" + 
				vm.sPasswordStrength + " ^^ ";

			dataService.usersChangePassword(sSaveString)
			.then(function(data) {
				if (data[0].RESULTCODE == "Success") {
					$rootScope.bPasswordExpired = false;
					modalService.okAlert("Save Successful", 
						msg + "Your password has been updated successfully!");
	
					if (appValidationService.validateAccess() == "Valid") {
						$rootScope.sCurForm = 'Statistics Records';
						$state.go('statHist');
					} else { 
						$rootScope.sCurForm = 'Login';
						$state.go('login'); 
					}	
				} else {
					$state.reload();
					modalService.okAlert("Save Failed", msg + data[0].RESULTREASON);
				}
			});
		}
    }
    
    
/* Externally Called Functions: */

    vm.cancelChanges = function() {
	    if ($rootScope.bPasswordExpired) {
			$state.reload();
		} else {
			//Return to Landing page for app:
			$rootScope.sCurForm = 'Statistics Records';
			$state.go('statHist');
		}
	};
    
    vm.checkPWStrength = function() {
		var pwReturn = passwordStrength.getPWStrength(vm.data.newPW);
		vm.sPasswordStrength = pwReturn.strength;
		vm.sPWClass = pwReturn.class;
	};  

    vm.confirmReadyToSave = function(item) {
		switch (item) {
			case "email":
				validateEmail();	
			break;
			case "pw":
				validatePW();
			break;
		}
	};
	
	vm.enterKeyHandler = function($event) {
		if ($event.keyCode === 13) {
			if (vm.bReadyToSave == "true") {
				if (vm.bReadyToSaveEmail == true) {
					saveNewEmail();
				} else if (vm.bReadyToSavePW == true) {
					saveNewPassword("");
				}	
			}	
		}  
	};
	
	vm.logOut = function() {
		loginService.logout();
		$state.go('login'); 
	}

    vm.saveChanges = function() {
		if (vm.bReadyToSave == "true") {
			if (vm.bReadyToSaveEmail == true) {
				saveNewEmail();
			} else if (vm.bReadyToSavePW == true) {
				saveNewPassword("");
			}	
		} else if (vm.data.newPW != "" && vm.data.confirmPW != "") {
			validatePW();
		} else if (vm.data.email != "" && vm.data.confirmEmail != "") {
			validateEmail();
		} else { 
			modalService.okAlert("Oops!", 
				"We did not find any data changes to Save."); 
		}
    };
    
}
(function() {
	'use strict';

	angular
		.module('stats')
		.config(routerConfig);


	function routerConfig($stateProvider, $urlRouterProvider) {
		$stateProvider
		.state('index', {
			url: '/index.html',
			templateUrl: 'app/views/login.html',
			controller: 'LoginController',
			controllerAs: 'vmLI'
		})
		.state('login', {
			url: '/login',
			templateUrl: 'app/views/login.html',
			controller: 'LoginController',
			controllerAs: 'vmLI'
		})
		.state('about', {
			url: '/about',
			templateUrl: 'app/views/about.html'
		})
		.state('chgPW', {
			url: '/chgPW',
			templateUrl: 'app/views/chgPW.html',
			controller: 'ChgPasswordController',
			controllerAs: 'vmCP',
			params: {
				bHideOldPw: false
			}
		})
		.state('staff', {
			url: '/staff',
			templateUrl: 'app/views/staff.html',
			controller: 'StaffController',
			controllerAs: 'vmST'
		})
		.state('helpDesk', {
			url: '/helpDesk',
			templateUrl: 'app/views/helpDesk.html',
			controller: 'HelpDeskController',
			controllerAs: 'vmHD'
		})
		.state('print', {
			url: '/print',
			templateUrl: 'app/views/print.html',
			controller: 'PrintController',
			controllerAs: 'vmPrt',
			params: {
				arrTables: [],
				sChurchName: "",
				statRecord: {}
			}
		})
		.state('statHist', {
			url: '/statHist',
			templateUrl: 'app/views/statHist.html',
			controller: 'StatHistoryController',
			controllerAs: 'vmSH',
			params: { 
				iChurchID: 0,
				sChurchName: "" }
		})
		.state('statEntry', {
			url: '/statEntry',
			templateUrl: 'app/views/statEntry.html',
			controller: 'StatEntryController',
			controllerAs: 'vmSE',
			params: {
				sChurchName: "",
				statRecord: {}
			}	
		});

		$urlRouterProvider.otherwise('/index.html');
	}

})();

(function() {
	'use strict';

	angular
		.module('stats')
// /*TEST*/.constant('version', '0.000.035')
/*LIVE*/.constant('version', '2.000.000')
		.constant('authServiceCFC', 'https://umcdata.net/Falcon/libCFCs/AuthService.cfc')
		.constant('mcWebCFC', 'https://umcdata.net/Falcon/libCFCs/MC_Web.cfc')
		.constant('statsCFC', 'https://umcdata.net/Falcon/libCFCs/StatsJS.cfc')
		.constant('helpDeskCFC', 'https://umcdata.net/Falcon/libCFCs/HelpDesk.cfc')
//		.constant('testCFC', 'https://umcdata.net/Falcon/libCFCs/Testing.cfc')
		.constant('chrgApptsURL', 'https://umcdata.net/MissionConnect/Public/ChrgAppts/index.html')
		.constant('lclURL', 'https://umcdata.net/MissionConnect/Public/MCWebApps/LCLeaders/#/index.html')
		.constant('mcWebAppsURL', 'https://umcdata.net/MissionConnect/Public/MCWebApps/#/index.html')
		.constant('minFinURL', 'https://umcdata.net/MissionConnect/Public/RcvWeb/#/login')
		.constant('protectURL', 'https://umcdata.net/MissionConnect/Public/MCWebApps/Protect/#/index.html')
// /*TEST*/.constant('statsURL', 'https://umcdata.net/Falcon/Web_TestSite/MCWebApps/Statistics/#/index.html')
/*LIVE*/.constant('statsURL', 'https://umcdata.net/MissionConnect/Public/MCWebApps/Statistics/#/index.html')
		.constant('vancoPay', 'https://umcdata.net/MissionConnect/Public/VancoPay/#/index.html')
		.constant('custData', [
			{
				"DataSource":"",
				"DatabaseID":"GSS",
				"CustomerName":"<No Selection>"
			},
			{
				"DataSource":"FalconArk",
				"DatabaseID":"ARK",
				"CustomerName":"Arkansas Conference"
			},
			{
				"DataSource":"FalconDemo",
				"DatabaseID":"Demo",
				"CustomerName":"Demo Database"
			},
			//EOH
			{
				"DataSource":"FalconKy",
				"DatabaseID":"KY",
				"CustomerName":"Kentucky Conference"
			},
			{
				"DataSource":"FalconLa",
				"DatabaseID":"LA",
				"CustomerName":"Louisiana Conference"
			},
			{
				"DataSource":"FalconMc",
				"DatabaseID":"MC",
				"CustomerName":"McCurdy Ministries Community Center"
			},
			{
				"DataSource":"FalconMem",
				"DatabaseID":"MEM",
				"CustomerName":"Memphis Conference"
			},
			{
				"DataSource":"FalconMo",
				"DatabaseID":"MO",
				"CustomerName":"Missouri Conference",
				"ProRef": "Safe Sanctuary References"

			},
			//MN,FalconMinn
			{
				"DataSource":"FalconNm",
				"DatabaseID":"NM",
				"CustomerName":"New Mexico Conference"
			},
			{
				"DataSource":"FalconNwtx",
				"DatabaseID":"NWTX",
				"CustomerName":"Northwest Texas Conference",
				"ProRef":"Volunteer References"
			},
			//PR
			{
				"DataSource":"FalconRm",
				"DatabaseID":"RM",
				"CustomerName":"Rocky Mountain Conference"
			},
			{
				"DataSource":"FalconSwtx",
				"DatabaseID":"SWTX",
				"CustomerName":"Rio Texas Conference"
			},
			{
				"DataSource":"FalconSg",
				"DatabaseID":"SGA",
				"CustomerName":"South Georgia Conference"
			},
			{
				"DataSource":"FalconTenn",
				"DatabaseID":"TN",
				"CustomerName":"Tennessee Conference"
			},
			{
				"DataSource":"FalconUny",
				"DatabaseID":"UNY",
				"CustomerName":"Upper New York Conference"
			},
			//VID,FalconVideos
			//WI,FalconWi
			//WOH,FalconWoh
			{
				"DataSource":"FalconYw",
				"DatabaseID":"YW",
				"CustomerName":"Mountain Sky Conference"
			}
		])

		.constant('custDataDev', [
			{
				"DataSource":"FalconArkDev",
				"DatabaseID":"ARK-DEV",
				"CustomerName":"Arkansas Conference (ARK-DEV)"
			},
			{
				"DataSource":"FalconKyDev",
				"DatabaseID":"KY-DEV",
				"CustomerName":"Kentucky Conference (KY-DEV)"
			},
			{
				"DataSource":"FalconLaDev",
				"DatabaseID":"LA-DEV",
				"CustomerName":"Louisiana Conference (LA-DEV)"
			},
			{
				"DataSource":"FalconMcDev",
				"DatabaseID":"MC-DEV",
				"CustomerName":"McCurdy Ministries (MC-DEV)"
			},
			{
				"DataSource":"FalconMemDev",
				"DatabaseID":"MEM-DEV",
				"CustomerName":"Memphis Conference (MEM-DEV)"
			},
			{	
				"DataSource":"FalconMoDev",
				"DatabaseID":"MO-DEV",
				"CustomerName":"Missouri Conference (MO-DEV)",
				"ProRef": "Safe Sanctuary References"
			},
			{
				"DataSource":"FalconNmDev",
				"DatabaseID":"NM-DEV",
				"CustomerName":"New Mexico Conference (NM-DEV)"
			},
			{
				"DataSource":"FalconNwtxDev",
				"DatabaseID":"NWTX-DEV",
				"CustomerName":"NWTX Conference (NWTX-DEV)",
				"ProRef":"Volunteer References"
			},
			{
				"DataSource":"FalconSwtxDev",
				"DatabaseID":"SWTX-DEV",
				"CustomerName":"Rio Texas Conference (RIO-DEV)"
			},
			{
				"DataSource":"FalconSgDev",
				"DatabaseID":"SGA-DEV",
				"CustomerName":"South Georgia Conference (SGA-DEV)"
			},
			{
				"DataSource":"FalconTennDev",
				"DatabaseID":"TN-DEV",
				"CustomerName":"Tennessee Conference (TN-DEV)"
			},
			{
				"DataSource":"FalconUnyDev",
				"DatabaseID":"UNY-DEV",
				"CustomerName":"Upper New York Conference  (UNY-DEV)"
			},
			{
				"DataSource":"FalconVideos",
				"DatabaseID":"VID",
				"CustomerName":"Demo Conference",
				"ProRef":"Safe Sanctuary References"
			}
		]);

})();

angular.module("stats").run(["$templateCache", function($templateCache) {$templateCache.put("app/modals/modAlert.html","<div><!-- ng-controller=\"ModalController as vmMod\" --><div class=\"modal-header MCGrn75\"><h3 class=modal-title>{{ vmMod.sTitle }}</h3></div><div class=modal-body><!-- HTML Message: --><p ng-bind-html=vmMod.sAlertMsg></p></div><div class=modal-footer><!-- modType=\'OK\': --><div ng-show=\"vmMod.modType==\'OK\'\" class=divR><button class=\"btn btn-primary\" type=button ng-click=vmMod.ok()>OK</button></div><!-- modType=\'print\': --><div ng-show=\"vmMod.modType==\'print\'\"><div>Click the Open button to go to the Statistics report in a new tab of your browser. Then print from that page.</div><button class=\"btn btn-default\" type=button ng-click=vmMod.cancel()>Cancel</button> <button class=\"btn MCGold\" type=button ng-click=vmMod.open()>Open</button></div></div></div>");
$templateCache.put("app/modals/modConfSelectModal.html","<div><!-- ng-controller=\"ModalController as vmSel\" --><div class=\"modal-header MCGold\"><h3 class=modal-title>Please Select a Conference</h3></div><div class=\"modal-body text-center\"><div><p>Oops! We are having trouble locating your account, and need a little more information.<br>Please make a selection from the following:</p><span ng-repeat=\"item in vmSel.confs\"><button class=\"btn-sm btn-default\" style=\"width: 250px\" ng-click=vmSel.ok(item)>{{item.CONFNAME}}</button><br></span></div></div><div class=modal-footer><button class=\"btn btn-default\" ng-click=vmSel.cancel()>Cancel</button></div></div>");
$templateCache.put("app/modals/modTimeout.html","<div><!-- ng-controller=\"ModalTimeoutController as modTO\" --><div class=\"modal-header MCGrn75\"><h3 class=modal-title>Session Timeout</h3></div><div class=modal-body><!-- HTML Message: --><p>Are you still there?</p><p>Inactivity has been detected. If you would like to continue this session, please click the Continue button within {{ modTO.secTimer }} seconds.</p></div><div class=modal-footer><!-- modType=\'Continue\': --><div class=divR><button class=\"btn btn-primary\" type=button ng-click=modTO.continue()>Continue</button></div></div></div>");
$templateCache.put("app/modals/print.html","<div><!-- ng-controller=\"PrintController as vmPrt\" --><div class=modal-header><h3 class=modal-title>Print Statistics</h3></div><div class=modal-body><h5>Select to include only the Current Year (1-year) or Current and Previous Year<br>(2-years):</h5><div class=divCtr><div style=\"width: 150px; margin:auto\"><input type=radio name=years value=0 ng-model=vmPrt.optPrint autocomplete=off>&nbsp;1-year&nbsp;&nbsp;&nbsp;&nbsp; <input type=radio name=years value=1 ng-model=vmPrt.optPrint autocomplete=off>&nbsp;2-years&nbsp;&nbsp;</div></div><h5>Select the Tables to Print:</h5><div class=divCtr><div style=\"width: 150px; margin:auto\"><input type=checkbox name=tables ng-model=vmPrt.bAllTables>&nbsp;&nbsp;All Tables<br><br><div ng-show=\"vmPrt.bAllTables==false\" ng-repeat=\"item in vmPrt.arrTables\"><input type=checkbox name=tables ng-model=item.selected> &nbsp;{{ item.FORM }}</div></div></div></div></div><div class=modal-footer><div class=divR><button class=\"btn btn-default\" type=button ng-click=vmPrt.cancel()>Cancel</button> <button class=\"btn mcGold\" type=button ng-click=vmPrt.printStatistics()>Print Statistics</button></div></div>");
$templateCache.put("app/modals/rptReady.html","<div><!-- ng-controller=\"ModalController as vmMod\" --><div class=modal-header><h3 class=modal-title>Print Statistics</h3></div><div class=modal-body><h5>Your report is ready to print!</h5></div><div class=modal-footer><div>Click the Open button to go to the Statistics report in a new tab of your browser. Then print from that page.</div><div class=divR><button class=\"btn btn-default\" type=button ng-click=vmMod.cancel()>Cancel</button> <button class=\"btn mcGold\" type=button ng-click=vmMod.open()>Open</button></div></div></div>");
$templateCache.put("app/views/about.html","<section class=section><div align=center><span style=\"font-size: 16px\">This software was created by<br>Great Spirit Systems Corporation&trade;<br>specializing in software development to<br>meet the unique needs of religious<br>organizations since 1994.<br><br>Inquiries should be addressed to<br><font color=#0000FF><a href=\"mailto:al@greatspirit.com?subject=Inquiry\"><u>al@greatspirit.com</u></a></font></span></div></section>");
$templateCache.put("app/views/chgPW.html","<section class=section><!-- ChgPasswordController as vmCP --><div><!-- 	    <h5><b>Passwords cannot be changed for the Church Accounts. For further assistance, please contact your Conference office.</b></h5>	     --><h5><b>Tips for making the password stronger:</b></h5><ul><li>Make it longer</li><li>Use both UPPER &amp; lower case</li><li>Add a number</li><li>Add a special character: #*@!&amp;,^%</li></ul></div><div class=form-group ng-hide=vmCP.bHideOldPw><label for=txtOldPW>Old Password</label><input id=txtOldPW class=form-control type=text autofocus ng-model=vmCP.data.oldPW></div><h5>[New Password must not match old]</h5><div class=form-group><label for=txtNewPW>New Password</label><input id=txtNewPW class=form-control type=password ng-model=vmCP.data.newPW ng-change=vmCP.checkPWStrength() ng-blur=\"vmCP.confirmReadyToSave(\'pw\')\" ng-keypress=vmCP.enterKeyHandler($event)></div><div>Password Strength is&nbsp;&nbsp;<span id=pwStrength class=\"ng-class: vmCP.sPWClass\">&nbsp;&nbsp;<b>{{ vmCP.sPasswordStrength }}</b> &nbsp;&nbsp;</span></div><div class=form-group><label for=txtConfirmPW>Confirm Password</label><input id=txtConfirmPW class=form-control type=password ng-model=vmCP.data.confirmPW ng-blur=\"vmCP.confirmReadyToSave(\'pw\')\" ng-keypress=vmCP.enterKeyHandler($event)></div><h5 ng-hide=vmCP.bHideOldPw><b>Current User Account Email: {{ vmCP.sUserEmail }}</b></h5><div class=div ng-hide=vmCP.bHideOldPw><label for=email>Update Email Address</label><input id=email class=form-control type=text ng-model=vmCP.data.email ng-blur=\"vmCP.confirmReadyToSave(\'email\')\"></div><div class=div ng-hide=vmCP.bHideOldPw><label for=confirmEmail>Confirm Email Address</label><input id=confirmEmail class=form-control type=text ng-model=vmCP.data.confirmEmail ng-blur=\"vmCP.confirmReadyToSave(\'email\')\" ng-keypress=vmCP.enterKeyHandler($event)></div><div class=div><div class=divL ng-show=bPasswordExpired><button style=width:90px type=button ng-click=vmCP.logOut()>Log Out</button></div><div class=divR><button ng-click=vmCP.cancelChanges()>Cancel</button> <button id=saveData ng-class=vmCP.bReadyToSave style=width:90px ng-click=vmCP.saveChanges()>Save</button></div></div></section>");
$templateCache.put("app/views/helpDesk.html","<section class=section><!-- HelpDeskController vmHD --><div style=\"font-size: 21px; font-weight: bold\">MissionConnect: Help Desk</div><div class=form-group><label>Name:</label><input class=form-control placeholder=\"Enter Full Name\" type=text autofocus ng-model=vmHD.sUserFullName value=\"{{ vmHD.sUserFullName }}\" ng-change=vmHD.confirmReadyToSubmit()></div><div class=form-group><label>Email:</label><input class=form-control placeholder=\"Email Address\" type=text value=\"{{ vmHD.sUserEmail }}\" ng-model=vmHD.sUserEmail ng-change=vmHD.confirmReadyToSubmit()></div><div class=form-group><label>Describe the problem. Please include details.</label><textarea class=form-control ng-model=vmHD.sProblem ng-change=vmHD.confirmReadyToSubmit()></textarea></div><div><button id=submitHD class=btnCtr ng-class=vmHD.bReadyToSubmit ng-click=vmHD.submitHD()>Submit</button></div></section>");
$templateCache.put("app/views/login.html","<section><div class=section><div ng-show=vmLI.bShowConferences><h4 class=txtCtr>Select your Conference:</h4><div><select class=ddlCtr ng-change=vmLI.selectConference(cust) ng-model=vmLI.selConf ng-options=\"cust as cust.CustomerName for cust in vmLI.custDB | \n						orderBy:cust.DataSource\"></select></div></div><h5><b>Login to access Secure Applications</b><br><span class=txtMCRed>Username &amp; Password are Case Sensitive!</span></h5><div class=form-group><label for=txtUsername>Username</label><input id=txtUsername type=text class=form-control autofocus placeholder=Username ng-model=vmLI.sUsername ng-focus=vmLI.onFocus() ng-keypress=vmLI.enterKeyHandler($event)></div><div class=form-group><label for=txtPassword>Password</label><input id=txtPassword class=form-control type=password placeholder=Password ng-model=vmLI.sPassword ng-focus=vmLI.onFocus() ng-keypress=vmLI.enterKeyHandler($event)></div><div><div class=divL><button class=\"btn115 MCGold\" ng-click=vmLI.validateUserLogin() ng-keypress=vmLI.enterKeyHandler($event)>Login</button></div><div class=divR><button ng-click=vmLI.forgotPassword_clickHandler()>Forgot Password?</button></div></div><div class=div><h5>[For security reasons, the application will log off if idle for 30 minutes.]</h5></div></div></section>");
$templateCache.put("app/views/print.html","<section class=section><div><!-- ng-controller=\"PrintController as vmPrt\" --><div><h5>Select to include only the Current Year (1-year) or Current and Previous Year<br>(2-years):</h5><div class=divCtr><div style=\"width: 150px; margin:auto\"><input type=radio name=years value=0 ng-model=vmPrt.optPrint autocomplete=off>&nbsp;1-year&nbsp;&nbsp;&nbsp;&nbsp; <input type=radio name=years value=1 ng-model=vmPrt.optPrint autocomplete=off>&nbsp;2-years&nbsp;&nbsp;</div></div><h5>Select the Tables to Print:</h5><div class=divCtr><div style=\"width: 150px; margin:auto\"><input type=checkbox name=tables ng-model=vmPrt.bAllTables>&nbsp;&nbsp;All Tables<br><br><div ng-show=\"vmPrt.bAllTables!=true\" ng-repeat=\"item in vmPrt.arrTables\"><input type=checkbox name=tables ng-model=item.selected> &nbsp;{{ item.FORM }}</div></div></div></div></div><div><div><!--\n            <button class=\"btn btn-default\" type=\"button\" ng-click=\"vmPrt.goBack()\" style=\"float:left\">\n            	Return to Stats Entry</button>\n--><div style=float:left><img ng-src=\"{{ vmPrt.back.image }}\" alt=\"Return to Statistics Entry\" uib-tooltip=\"Return to Statistics Entry\" tooltip-placement=right tooltip-class=statTip1 ng-click=vmPrt.goBack()></div><button class=\"btn MCGold\" type=button style=float:right ng-click=vmPrt.printStatistics()>Print Statistics</button></div></div></section>");
$templateCache.put("app/views/staff.html","<section><!-- controllerAs: vmST --><div class=div><table class=\"table table-hover\"><thead><tr><th style=border-top-left-radius:8px>Location</th><th>Administrator</th><th>Email</th><th style=border-top-right-radius:8px>Phone</th></tr></thead><tbody><tr ng-repeat=\"item in vmST.arrContacts | orderBy: \'SEQ\' track by $index\"><td>{{ item.ITEM }}</td><td>{{ item.LISTDATA1 }}</td><td><a href=\"mailto:{{ item.LISTDATA2 }}\">{{item.LISTDATA2}}</a></td><td>{{ item.LISTDATA3 }}</td></tr></tbody></table></div></section>");
$templateCache.put("app/views/statEntry.html","<section><!-- controllerAs: vmSE --><div class=div><img ng-src=assets/images/left_32.png alt=\"Return to all Statistical Records for this church.\" uib-tooltip=\"Return to all Statistical Records for this church.\" tooltip-placement=right tooltip-class=statTip2 ng-click=vmSE.returnToStatsHist()> <button id=print style=\"float:right; width:70px\" ng-click=vmSE.print()>Print</button><h4>{{ vmSE.sChurchName }}</h4><div class=hr style=\"clear: both\"></div><div ng-show=\"vmSE.sTableText != \'\'\" class=div ng-bind-html=vmSE.sTableText></div></div><div class=div1><div style=float:right><div ng-show=\"vmSE.sPercentComplete != \'100% Complete\' || vmSE.bReadyToSave!=\'false\'\n		    	|| (vmSE.sPercentComplete == \'100% Complete\' && vmSE.bChkSumsOff==true)\" class=statusLg style=\"text-align:center; margin: 0\">{{ vmSE.sPercentComplete }}</div><div ng-show=\"vmSE.sPercentComplete==\'100% Complete\' && vmSE.bReadyToSave==\'false\'\n		    	&& vmSE.bChkSumsOff==false\" style=margin:0><button id=btnSubmit class=btnN style=width:185px ng-show=\"vmSE.selTable==\'Table 2 Worksheet\'\" ng-click=vmSE.submitTable()>Submit {{ vmSE.selTable }}</button> <button id=btnSubmit class=btnN style=width:165px ng-show=\"vmSE.selTable!=\'Table 2 Worksheet\'\" ng-click=vmSE.submitTable()>Submit {{ vmSE.selTable }}</button></div><div ng-show=\"vmSE.bSubmitted==false\" style=\"float:right; margin: 0\"><button class=btnN style=width:80px ng-click=vmSE.cancelHandler()>Cancel</button> <button id=saveData class=btnN ng-class=vmSE.bReadyToSave ng-click=vmSE.saveHandler()>Save</button></div></div><div class=btn-group ng-click=vmSE.changeTableHandler()><label class=\"btn btn-primary\" ng-model=vmSE.selTable uib-btn-radio=vmSE.arrTables[0].FORM ng-disabled=\"vmSE.arrTables[0].FORM!=vmSE.selTable &&\n	        		(vmSE.bReadyToSave==\'true\'||vmSE.bReadyToSave==\'warn\')\" uib-uncheckable=uncheckable>{{ vmSE.arrTables[0].FORM }}</label><label class=\"btn btn-primary\" ng-model=vmSE.selTable uib-btn-radio=vmSE.arrTables[1].FORM ng-disabled=\"vmSE.arrTables[1].FORM!=vmSE.selTable &&\n	        		(vmSE.bReadyToSave==\'true\'||vmSE.bReadyToSave==\'warn\')\" uib-uncheckable=uncheckable>{{ vmSE.arrTables[1].FORM }}</label><label class=\"btn btn-primary\" ng-model=vmSE.selTable uib-btn-radio=vmSE.arrTables[2].FORM ng-disabled=\"vmSE.arrTables[2].FORM!=vmSE.selTable &&\n	        		(vmSE.bReadyToSave==\'true\'||vmSE.bReadyToSave==\'warn\')\" uib-uncheckable=uncheckable>{{ vmSE.arrTables[2].FORM }}</label><label class=\"btn btn-primary\" ng-model=vmSE.selTable ng-show=\"vmSE.arrTables[3].FORM != null\" uib-btn-radio=vmSE.arrTables[3].FORM ng-disabled=\"vmSE.arrTables[3].FORM!=vmSE.selTable &&\n	        		(vmSE.bReadyToSave==\'true\'||vmSE.bReadyToSave==\'warn\')\" uib-uncheckable=uncheckable>{{ vmSE.arrTables[3].FORM }}</label><label class=\"btn btn-primary\" ng-model=vmSE.selTable ng-show=\"vmSE.arrTables[4].FORM != null\" uib-btn-radio=vmSE.arrTables[4].FORM ng-disabled=\"vmSE.arrTables[4].FORM!=vmSE.selTable &&\n	        		(vmSE.bReadyToSave==\'true\'||vmSE.bReadyToSave==\'warn\')\" uib-uncheckable=uncheckable>{{ vmSE.arrTables[4].FORM }}</label></div></div><div class=div><table id=statsTable class=\"table table-hover\"><thead><th></th><th></th><th style=text-align:center>{{ vmSE.statRecord.FORMYEAR }}</th><th style=text-align:center>{{ vmSE.prevYear }}</th><th></th></thead><tbody><tr ng-repeat=\"item in vmSE.arrDataFields track by $index\"><!-- 			Line# @ beginning: --><td ng-class=\"{lnHeader:item.numDol==\'Header\', lnSubheader:item.numDol==\'Subheader\',\n			            lnItem:item.Ln != \'\'}\" style=\"white-space: nowrap\">{{ item.Ln }}</td><!-- 		    Statistic/Title: --><td ng-class=\"{itemHeader:item.numDol==\'Header\', itemSubheader:item.numDol==\'Subheader\',\n		            	itemText:item.Desc1 != \'\'}\"><p uib-tooltip=\"{{ item.Desc2 }}\" tooltip-placement=bottom-left tooltip-class=statTip>{{ item.Desc1 }}</p></td><!--			StatEntryFields: --><td ng-show=\"item.numDol==\'Number\'||item.numDol==\'Dollars\'\"><input class=input-sm ng-class=item.Locked type=text ng-disabled=\"item.Locked != \'Enter\' && item.Locked != \'ChkSumsOff\'\" ng-model=item.data ng-keypress=vmSE.enterAsTab($event,item.seq) ng-blur=vmSE.changeDataHandler(item)></td><!-- 			Yes/No Options:    	 --><td ng-show=\"item.numDol==\'Yes|No\'\"><input name={{item.statItem}} type=radio value=Yes ng-model=item.data ng-disabled=\"item.Locked != \'Enter\'\" ng-click=vmSE.changeDataHandler(item)>&nbsp;Yes&nbsp;&nbsp; <input name={{item.statItem}} type=radio value=No ng-model=item.data ng-disabled=\"item.Locked != \'Enter\'\" ng-click=vmSE.changeDataHandler(item)>&nbsp;No<!--	        PriorYearFields: (Read-Only) --></td><td ng-show=\"item.numDol==\'Number\'||item.numDol==\'Dollars\'||item.numDol==\'Yes|No\'\"><input class=input-sm style=\"background-color: #A8C6EE\" type=text ng-disabled=item.Locked ng-model=item.prevData></td><!--	        2-Column Text Fields: --><td colspan=2 ng-show=\"item.numDol==\'Text\'\"><input class=input-sm-text ng-class=item.Locked type=text ng-model=item.data ng-disabled=\"item.Locked != \'Enter\'\" ng-change=vmSE.changeDataHandler(item)></td><!-- 			Line# @ end: --><td ng-hide=\"item.numDol==\'Header\'||item.numDol==\'Subheader\'\" style=\"text-align:left; white-space: nowrap\">{{ item.Ln }}</td></tr></tbody></table></div></section>");
$templateCache.put("app/views/statHist.html","<section><!-- controllerAs: vmSH --><div><div class=status style=float:left>Username: {{vmSH.sUsername}}</div><div style=float:right ng-show=\"vmSH.arrChurches.length>1\"><input type=text class=form-control style=\"width: 300px\" ng-model=vmSH.sChurchName placeholder=\"Begin typing Name of Church\" uib-typeahead=\"church.CHURCHNAME for church in vmSH.arrChurches | \n		    		filter:{CHURCHNAME:$viewValue}\" typeahead-select-on-exact=true typeahead-show-hint=true typeahead-min-length=0 typeahead-on-select=vmSH.loadSelectedChurch($item)></div><!-- | limitTo:8 --><div ng-bind-html=vmSH.sInstructions style=\"clear: both; width: 80%; margin:auto; text-align:center\"></div><h4 class=div style=\"margin: 0 auto\">{{vmSH.sChurchName}}</h4></div><div class=div><table class=\"table table-hover\"><thead><th style=border-top-left-radius:8px>Year</th><th>Table 1 Started</th><th>Table 1 Submitted</th><th ng-show=\"vmSH.showWS==true\">Table 2 WS Started</th><th ng-show=\"vmSH.showWS==true\">Table 2 WS Submitted</th><th>Table 2 Started</th><th>Table 2 Submitted</th><th>Table 3 Started</th><th>Table 3 Submitted</th><th ng-show=\"vmSH.showTable4==true\">Table 4 Started</th><th ng-show=\"vmSH.showTable4==true\">Table 4 Submitted</th><th ng-show=\"vmSH.showTable9==true\">Table 9 Started</th><th ng-show=\"vmSH.showTable9==true\">Table 9 Submitted</th><th style=\"text-align:center; border-top-right-radius:8px\">Open / View</th></thead><tbody><tr ng-repeat=\"stat in vmSH.arrStatRecords track by $index\"><td>{{ stat.FORMYEAR }}</td><!-- Table 1 --><td>{{ stat.TABLE1STARTEDDATE }}</td><td ng-show=\"stat.TABLE1SUBMITTEDDATE==\'100% Complete\' && \n			            stat.readyToSubmit==true\"><button class=MCGrn35 ng-disabled=\"stat.WEBLOCK==\'Locked\'\" ng-click=\"vmSH.submitTable(stat,\'Table 1\')\">Submit Table 1</button></td><td ng-show=\"stat.TABLE1SUBMITTEDDATE==\'100% Complete\' && \n			            stat.readyToSubmit==false\">100% Complete</td><td ng-hide=\"stat.TABLE1SUBMITTEDDATE==\'100% Complete\'\">{{ stat.TABLE1SUBMITTEDDATE }}</td><!-- Table 2WS (LA) --><td ng-show=\"vmSH.showWS==true\">{{ stat.TABLE2WSSTARTEDDATE }}</td><td ng-show=\"vmSH.showWS == true && stat.TABLE2WSSUBMITTEDDATE==\'100% Complete\'\n			            && stat.readyToSubmit==true\"><button class=MCGrn35 ng-disabled=\"stat.WEBLOCK==\'Locked\'\" ng-click=\"vmSH.submitTable(stat,\'Table 2 Worksheet\')\">Submit Table 2 Worksheet</button></td><td ng-show=\"stat.TABLE2WSSUBMITTEDDATE==\'100% Complete\' && \n			            stat.readyToSubmit==false\">100% Complete</td><td ng-hide=\"stat.TABLE2WSSUBMITTEDDATE==\'100% Complete\' || vmSH.showWS==false\">{{ stat.TABLE2WSSUBMITTEDDATE }}</td><!-- Table 2 --><td>{{ stat.TABLE2STARTEDDATE }}</td><td ng-show=\"stat.TABLE2SUBMITTEDDATE==\'100% Complete\' && \n			            stat.readyToSubmit==true\"><button class=MCGrn35 ng-disabled=\"stat.WEBLOCK==\'Locked\'\" ng-click=\"vmSH.submitTable(stat,\'Table 2\')\">Submit Table 2</button></td><td ng-show=\"stat.TABLE2SUBMITTEDDATE==\'100% Complete\' && \n			            stat.readyToSubmit==false\">100% Complete</td><td ng-hide=\"stat.TABLE2SUBMITTEDDATE==\'100% Complete\'\">{{ stat.TABLE2SUBMITTEDDATE }}</td><!-- Table 3 --><td>{{ stat.TABLE3STARTEDDATE }}</td><td ng-show=\"stat.TABLE3SUBMITTEDDATE==\'100% Complete\' &&\n			            stat.readyToSubmit==true\"><button class=MCGrn35 ng-disabled=\"stat.WEBLOCK==\'Locked\'\" ng-click=\"vmSH.submitTable(stat,\'Table 3\')\">Submit Table 3</button></td><td ng-show=\"stat.TABLE3SUBMITTEDDATE==\'100% Complete\' && \n			            stat.readyToSubmit==false\">100% Complete</td><td ng-hide=\"stat.TABLE3SUBMITTEDDATE==\'100% Complete\'\">{{ stat.TABLE3SUBMITTEDDATE }}</td><!-- Table 4 --><td ng-show=\"vmSH.showTable4==true\">{{ stat.TABLE4STARTEDDATE }}</td><td ng-show=\"vmSH.showTable4 == true && stat.TABLE4SUBMITTEDDATE==\'100% Complete\'\n			            && stat.readyToSubmit==true\"><button class=MCGrn35 ng-disabled=\"stat.WEBLOCK==\'Locked\'\" ng-click=\"vmSH.submitTable(stat,\'Table 4\')\">Submit Table 4</button></td><td ng-show=\"stat.TABLE4SUBMITTEDDATE==\'100% Complete\' && \n			            stat.readyToSubmit==false\">100% Complete</td><td ng-hide=\"stat.TABLE4SUBMITTEDDATE==\'100% Complete\' || vmSH.showTable4==false\">{{ stat.TABLE4SUBMITTEDDATE }}</td><!-- NEED HTML for Table9 if ever use... ADDED HERE! --><td ng-show=\"stat.WEBLOCK==\'Open\'\"><button class=MCGrn35 uib-tooltip=\"Click to Enter Statistics\" tooltip-placement=left tooltip-class=statTip ng-click=vmSH.openStat(stat)>Open</button></td><td ng-show=\"stat.WEBLOCK==\'Locked\'\"><button class=MCGrn35 uib-tooltip=\"Read-Only view of Statistics\" tooltip-placement=left tooltip-class=statTip ng-click=vmSH.openStat(stat)>View</button></td></tr></tbody></table></div></section>");}]);